/* Terra-Build engine.
 *
 * Lifted out of sections/terra-build.liquid 2026-08-03: the section had
 * grown past Shopify's 256KB template ceiling, which made it unsavable by
 * any path that validates size. Assets have no such limit.
 *
 * EDIT THIS FILE, not a copy pasted back into the section. The section now
 * carries only markup, CSS, the schema, and a small inline <script> that
 * sets window.TerraBuildConfig - see "Config bridge" below.
 */
    (function() {
      /* Config bridge. Everything Liquid used to interpolate into this
         file now arrives as data, set by the inline <script> the section
         emits immediately before this asset. Classic (non-defer) script
         tags run in document order, so the object is always in place by
         the time this line runs - and with several section instances on
         a page each execution reads the config written just before it. */
      var TB_CFG = window.TerraBuildConfig || {};
      var sectionId = TB_CFG.sectionId;
      var rootId = 'terra-target-customizer-' + sectionId;
      var svgNs = 'http://www.w3.org/2000/svg';
      var STORAGE_KEY = 'terra-build-custom-preset';

      /* v51: Cross-tool unit-system persistence. Shared across all
         Terra tools that have a metric/imperial toggle (Terra-Build,
         Terra-Dial). User's most recent toggle in any tool wins;
         every tool reads on init (after preset apply, before URL
         params override) and writes on every change. Storage event
         listener picks up cross-tab changes. */
      var UNIT_SYSTEM_KEY = 'terra-unit-system';
      function readStoredUnitSystem() {
        try {
          var v = localStorage.getItem(UNIT_SYSTEM_KEY);
          return (v === 'metric' || v === 'imperial') ? v : null;
        } catch (e) { return null; }
      }
      function writeStoredUnitSystem(unit) {
        try { localStorage.setItem(UNIT_SYSTEM_KEY, unit); } catch (e) {}
      }
      /* Idempotent unit apply — same code path as the click handler
         minus the markNonPromoting/onUserChange side-effects (callers
         that need those still call them explicitly). */
      function applyUnitSystem(newUnit) {
        if (newUnit !== 'metric' && newUnit !== 'imperial') return false;
        var prevUnit = getActiveUnit();
        if (prevUnit === newUnit) return false;
        setActive('#terra-unit-grid-' + sectionId + ' .terra-choice-button',
                  'data-unit', newUnit);
        refreshUnitDependentControls(newUnit, prevUnit);
        return true;
      }

      /* ── Klaviyo email-capture config ── (v46)
         Public key and list ID are pulled from theme-editor settings so
         the merchant can configure without code changes. Both blank =
         the email-capture UI is omitted from the markup entirely (see
         the Liquid `if` guard around .terra-email-capture in the
         body), and submitEmailCapture() is never bound. */
      /* Defaults live in the bridge (Liquid `default:` filters), so all
         three keys are always present and this needs no fallbacks. */
      var KLAVIYO_CFG = TB_CFG.klaviyo || { publicKey: '', listId: '', successText: '' };

      /* ── Marker presets (mm, centre-to-centre) ──
         TT1-TT5 are square and keep the scalar `spacing` (saved Custom
         presets reference it). TT6-TT9 are RECTANGULAR (spacingX/spacingY);
         markerPresetXY() gives both shapes one {x,y} code path.
         2026-08-03: TT6-TT9 are one page-filling preset per paper+orientation
         (A4-P, A4-L, A3-P, A3-L), sized with the conditions row ON so the
         choice survives that toggle and kept 2-5mm inside markerFitsArea -
         the true maxima sit EXACTLY on the limit. The printed range uses the
         same four. Aim is bounded by the SHORT axis: wider != bigger aim. */
      var MARKER_SIZE_MM = 20;
      var MARKER_PRESETS = {
        tt1: { spacing: 75,  label: 'TT1' },
        tt2: { spacing: 100, label: 'TT2' },
        tt3: { spacing: 120, label: 'TT3' },
        tt4: { spacing: 150, label: 'TT4' },
        tt5: { spacing: 180, label: 'TT5' },
        /* 100m MOA generation (2026-08-07). Replaced TT6-TT9 outright rather
           than sitting beside them: the site has not launched, so no printed
           TT6-TT9 sheet exists to keep working, and two generations in one
           picker is how a customer chooses a preset 1-2% off and gets a
           plausible wrong answer instead of an obvious failure.
           One rule generates all four: 20mm markers with centres 25mm in from
           every page edge, so 15mm of clear paper always lies outside a marker
           and the rectangle is EXACTLY page-centred - which is what makes the
           engine's aim point (rectangle centre) land on the target's aim. */
        tt13: { spacingX: 160, spacingY: 247, label: 'TT13' },   // A4 portrait
        tt11: { spacingX: 247, spacingY: 160, label: 'TT11' },   // A4 landscape
        tt12: { spacingX: 247, spacingY: 370, label: 'TT12' },   // A3 portrait
        tt10: { spacingX: 370, spacingY: 247, label: 'TT10' },   // A3 landscape
        /* US paper, 2026-08-08. Same rule on Letter 215.9x279.4 and Tabloid
           279.4x431.8. Exact at 0.1mm - never round these. */
        tt17: { spacingX: 165.9, spacingY: 229.4, label: 'TT17' }, // Letter portrait
        tt15: { spacingX: 229.4, spacingY: 165.9, label: 'TT15' }, // Letter landscape
        tt16: { spacingX: 229.4, spacingY: 381.8, label: 'TT16' }, // Tabloid portrait
        tt14: { spacingX: 381.8, spacingY: 229.4, label: 'TT14' }  // Tabloid landscape
      };
      /* Largest first, by footprint area. This order now serves only the
         IN-AREA fit (TT1-TT5): resolveBestFitMarker() skips page codes, because
         TT10-TT17 are placed by resolvePageMarker() from the PAPER, never by
         fitting. That also retires the A3/Tabloid overlap this comment used to
         warn about - each paper names its own code, so A3 geometry cannot land
         on a Tabloid page. The page codes stay listed so the family is
         documented in one place; skipping them is explicit, not accidental. */
      var MARKER_ORDER_LARGE_FIRST = ['tt12', 'tt10', 'tt16', 'tt14', 'tt11', 'tt13', 'tt17', 'tt15', 'tt5', 'tt4', 'tt3', 'tt2', 'tt1'];

      /* Preset -> {x, y} spacing pair. Square presets report the same value
         on both axes, so callers never branch on shape. */
      function markerPresetXY(preset) {
        if (!preset) return null;
        var x = (preset.spacingX != null) ? preset.spacingX : preset.spacing;
        var y = (preset.spacingY != null) ? preset.spacingY : preset.spacing;
        return { x: x, y: y };
      }

      /* Spacing pairs are compared by value, never by identity - they are
         rebuilt on each render, so `===` would always be false. */
      function markerXYEquals(a, b) {
        return !!a && !!b && a.x === b.x && a.y === b.y;
      }

      /* Label for a drawn spacing pair, or null when it matches no preset
         (Custom layouts can produce spacings we never named). */
      function markerLabelForXY(sp) {
        if (!sp) return null;
        var keys = Object.keys(MARKER_PRESETS);
        for (var i = 0; i < keys.length; i += 1) {
          if (markerXYEquals(markerPresetXY(MARKER_PRESETS[keys[i]]), sp)) {
            return MARKER_PRESETS[keys[i]].label;
          }
        }
        return null;
      }

      /* ── Page markers (TT10-TT17), 2026-09-11 ──
         TT10-TT17 are PAGE codes, one per paper + orientation: 20mm markers
         whose centres sit 25mm in from every page edge, so the rectangle is
         page - 50 and exactly page-centred. That is what the pre-made web PDFs
         print (Terra-Confirm's own detector reads them 24.8-25.2mm in, centred
         to 0.2mm) and the rectangle Terra-Confirm looks up from ?m=.
         THE BUG THIS REPLACES: these codes went through markerFitsArea() like
         TT1-TT5, against the space BETWEEN the header and the footer - always
         too short for page - 50. So auto silently fell through: A3 landscape
         and portrait drew TT11 (the A4 rectangle) mid-sheet, A4 drew TT3/TT4,
         and choosing TT10-TT13 by hand drew NO markers at all. A page code is
         now only ever drawn at page geometry, on its own paper, on a page with
         ONE aim point; every in-area placement uses TT1-TT5.
         Terra-Confirm constraints these values are built around:
         - aim = centre of the rectified marker rectangle (getAimPx default;
           saveSession hard-codes canvas.width/2), so the aim moves to PAGE
           centre whenever page markers are on - any offset is a silent POI bias;
         - scoreMarker compares the 20mm body with a 1.6x (32mm) square, so
           nothing may print within 16mm of a marker centre: a white pad is
           knocked out behind each marker, and the header, QR, conditions band
           and notes strip keep clear of the corners. */
      var PAGE_MARKER_INSET_MM = 25;
      var PAGE_MARKER_PAD_MM = 32;
      var PAGE_MARKER_CLEAR_MM = 44;     /* pad edge at 41mm + 3mm air */
      var QR_SIZE_MM = 16;
      var PAGE_QR_RIGHT_GAP_MM = 42;     /* QR right edge sits 1mm inboard of the pad */
      var PAGE_MARKER_CODE = {
        A4:      { portrait: 'tt13', landscape: 'tt11' },
        A3:      { portrait: 'tt12', landscape: 'tt10' },
        LETTER:  { portrait: 'tt17', landscape: 'tt15' },
        TABLOID: { portrait: 'tt16', landscape: 'tt14' }
      };
      var PAGE_MARKER_PAPER_NAME = {
        tt13: 'A4 portrait', tt11: 'A4 landscape', tt12: 'A3 portrait', tt10: 'A3 landscape',
        tt17: 'Letter portrait', tt15: 'Letter landscape', tt16: 'Tabloid portrait', tt14: 'Tabloid landscape'
      };
      /* One aim per page. Cold bore and multi-grid carry several aims, and a
         page rectangle can be centred on only one of them. */
      var PAGE_MARKER_STYLES = { single: true, diamond: true, zero_sheet: true };

      function isPageMarkerKey(key) {
        return !!(MARKER_PRESETS[key] && MARKER_PRESETS[key].spacingX != null);
      }

      /* { key, spacing, aim } when this page carries page markers, else null. */
      function resolvePageMarker(config) {
        var mode = config.markerMode;
        if (!mode || mode === 'none' || !PAGE_MARKER_STYLES[config.targetStyle]) return null;
        var byPaper = PAGE_MARKER_CODE[config.paperSize];
        var key = byPaper ? byPaper[config.orientation] : null;
        if (!key || (mode !== 'auto' && mode !== key)) return null;
        var sp = markerPresetXY(MARKER_PRESETS[key]);
        var dims = config.dims;
        /* The code must describe THIS page, or the print and the QR disagree. */
        if (!sp || !dims ||
            Math.abs(sp.x - (dims.width - 2 * PAGE_MARKER_INSET_MM)) > 0.01 ||
            Math.abs(sp.y - (dims.height - 2 * PAGE_MARKER_INSET_MM)) > 0.01) return null;
        if (config.aimStyle === 'sticker-guide' &&
            (Math.min(sp.x, sp.y) - MARKER_SIZE_MM) - 4 < (parseFloat(config.scaledAimSize) || 0)) return null;
        return { key: key, spacing: sp, aim: { x: dims.width / 2, y: dims.height / 2 } };
      }

      function pageAimPoint(config, aimPoint) {
        return config.pageMarker ? { x: config.pageMarker.aim.x, y: config.pageMarker.aim.y } : aimPoint;
      }

      function pageEdgeInset(config) {
        return config.pageMarker ? PAGE_MARKER_CLEAR_MM : 12;
      }

      /* resolveAimAndMarker() with the spacing already fixed by the page. */
      function resolveAimAndMarkerOnPage(area, aimPoint, config) {
        var page = config.pageMarker;
        if (!page) return resolveAimAndMarker(area, aimPoint, config);
        if (config.aimStyle === 'sticker-guide') {
          var byCellOnly = Math.min(area.width, area.height) - 12;
          var locked = constrainAimSizeToArea(area, aimPoint, Math.min(config.scaledAimSize, byCellOnly));
          return { markerSpacing: page.spacing, maxAim: locked, effectiveAim: locked };
        }
        var maxAim = computeMaxAimForArea(area, page.spacing);
        return {
          markerSpacing: page.spacing,
          maxAim: maxAim,
          effectiveAim: constrainAimSizeToArea(area, aimPoint, Math.min(config.scaledAimSize, maxAim))
        };
      }

      /* Pads first (they knock out grid, rings and labels under the corners),
         then the four markers. Called after the target style has drawn and
         before the header, QR, conditions and notes, which keep clear. */
      function addPageMarkers(svg, dims, sp) {
        var cx = dims.width / 2, cy = dims.height / 2, hx = sp.x / 2, hy = sp.y / 2;
        var half = PAGE_MARKER_PAD_MM / 2;
        var corners = [[cx - hx, cy - hy, 'tl'], [cx + hx, cy - hy, 'tr'], [cx - hx, cy + hy, 'bl'], [cx + hx, cy + hy, 'br']];
        /* A grid label half under a pad prints as a clipped glyph; drop it. */
        forEachNode(svg.querySelectorAll('.terra-grid-labels text'), function(t) {
          var tx = parseFloat(t.getAttribute('x')), ty = parseFloat(t.getAttribute('y'));
          var fs = parseFloat(t.getAttribute('font-size')) || 3.6;
          var w = (t.textContent || '').length * fs * 0.62 + 1;
          var anchor = t.getAttribute('text-anchor');
          var x0 = anchor === 'end' ? tx - w : (anchor === 'middle' ? tx - w / 2 : tx);
          for (var i = 0; i < corners.length; i += 1) {
            if (x0 < corners[i][0] + half && x0 + w > corners[i][0] - half &&
                ty - fs < corners[i][1] + half && ty + 0.5 > corners[i][1] - half) {
              t.parentNode.removeChild(t);
              return;
            }
          }
        });
        for (var p = 0; p < corners.length; p += 1) {
          addRect(svg, corners[p][0] - half, corners[p][1] - half, PAGE_MARKER_PAD_MM, PAGE_MARKER_PAD_MM,
                  { fill: '#ffffff', stroke: 'none', 'class': 'terra-marker-pad' });
        }
        for (var m = 0; m < corners.length; m += 1) {
          addReferenceMarker(svg, corners[m][0], corners[m][1], corners[m][2]);
        }
      }

      /* Module state for values that aren't tied to a visible UI control.
         Reset when a preset is applied. */
      var runtimeState = {
        moaRings: 0,
        multiPage: 1,
        multiPageTitles: null,
        pageTitleOverride: null
      };

      /* ── Presets (all with explicit gridStrength) ── */
      var presets = {
        /* Cold Bore 1P — single page landscape side-by-side, range grid */
        cold_bore_ss: {
          targetStyle: 'cold_bore',
          paperSize: 'A4',
          orientation: 'landscape',
          /* Grid defaults are MOA-relative from 2026-08-07. gridSize must be
             the mm ACTUALLY DRAWN at this preset's distance or it contradicts
             gridMode, so both are stated: 1/4 MOA at 100 m = 7.27 mm. */
          gridSize: 7.27,
          gridMode: 'moa-quarter',
          gridStrength: 'range',
          aimStyle: 'crosshair',
          aimSize: 400,
          distance: '100m',
          notes: '',
          showNotes: false,
          showGridLabels: true,
          gridLabelUnit: 'moa',
          markerMode: 'auto',
          holdover: 'off',
          ethicalGame: 'off',
          conditionsRow: false,
          moaRings: 0,
          multiPage: 1
        },
        /* Cold Bore 2P — 2 identical singular portrait pages, range grid,
           first labelled "COLD BORE SHOT", second "FOLLOW-UP GROUP" (g). */
        cold_bore_s2: {
          targetStyle: 'single',
          paperSize: 'A4',
          orientation: 'portrait',
          gridSize: 14.54,            // 1/2 MOA at 100 m
          gridMode: 'moa-half',
          gridStrength: 'range',
          aimStyle: 'crosshair',
          aimSize: 400,
          distance: '100m',
          notes: '',
          showNotes: false,
          showGridLabels: true,
          gridLabelUnit: 'moa',
          markerMode: 'auto',
          holdover: 'off',
          ethicalGame: 'off',
          conditionsRow: false,
          moaRings: 0,
          multiPage: 2,
          multiPageTitles: ['COLD BORE SHOT', 'FOLLOW-UP GROUP']
        },
        /* 100 m Zero — portrait, max square aim, MOA rings to grid extremities */
        zero_100: {
          targetStyle: 'zero_sheet',
          paperSize: 'A4',
          orientation: 'portrait',
          gridSize: 14.54,            // 1/2 MOA at 100 m
          gridMode: 'moa-half',
          gridStrength: 'field',
          aimStyle: 'square-rotated',
          aimSize: 400,
          distance: '100m',
          notes: '',
          showNotes: false,
          showGridLabels: true,
          gridLabelUnit: 'moa',
          markerMode: 'auto',
          holdover: 'off',
          ethicalGame: 'off',
          conditionsRow: false,
          /* Rings OFF (Greg, 2026-08-07). The 1/2 MOA grid already answers
             "how far off am I", and it answers it in the SAME unit the turret
             takes, read as radial offset. The rings answer a different
             question in a different convention (group size, diameter), so on a
             zero sheet they add a second set of numbers that disagrees with the
             first by design - at 100m a shot on the "2 MOA" ring reads 1.0 on
             the grid axis. One reading on a zeroing target, not two.
             Still a user toggle; this is only the preset's starting state. */
          moaRings: 0,
          multiPage: 1
        },
        /* Splatter Zero — same zero-sheet layout as zero_100 but the aim
           point is replaced with an 80 × 80 mm sticker placement guide
           (dashed perimeter, corner registration ticks, centre cross).
           Sized to the splatter-sticker product Greg sells; user prints,
           sticks, shoots, photographs, analyses in Terra-Impact.
           Grid labels suppressed (the splatter sticker takes care of
           visual reference); 20 mm grid keeps the page uncluttered;
           on-page title overrides "ZERO POINT" with the product label. */
        splatter_zero: {
          targetStyle: 'zero_sheet',
          paperSize: 'A4',
          orientation: 'portrait',
          /* 100 YARDS, not metres - the splatter sticker is a US-convention
             product. 1 MOA at 100 yd (91.44 m) = 26.60 mm, so 1/2 MOA is
             13.30 mm, NOT the 14.54 mm the metric presets use. */
          gridSize: 13.30,
          gridMode: 'moa-half',
          gridStrength: 'range',
          aimStyle: 'sticker-guide',
          aimSize: 80,
          distance: '100yd',
          notes: '',
          showNotes: false,
          showGridLabels: false,
          gridLabelUnit: 'moa',
          markerMode: 'auto',
          holdover: 'off',
          ethicalGame: 'off',
          conditionsRow: false,
          moaRings: 999,
          multiPage: 1,
          pageTitle: 'TERRA-80MM SPLATTER'
        },
        /* Ethical Range Rings — PORTRAIT, single aim, Deer 200 mm, 20 mm dot, range grid.
           No reference markers (placement-only target, not for Terra-Impact analysis),
           20 mm grid spacing keeps the page airy behind the ring overlay,
           grid labels off so the ethical rings read cleanly.

           PORTRAIT IS DELIBERATE, do not "tidy" it back to landscape. The deer vital
           ring is drawn at its true 200 mm diameter and is never scaled down (see
           addEthicalRangeRings) - overflow is clipped instead. Measured against the
           real layout constants, the aim sits at the centre of the content area and
           the ring needs 100 mm of clearance in every direction:
             A4 landscape  ->  71.5 mm vertical  =>  clipped 28.5 mm top AND bottom
             A4 portrait   ->  93.0 mm horizontal =>  clipped  7.0 mm left and right
           Landscape is the worst orientation for a 200 mm circle on A4. Only A3 fits
           it whole, and A3 is not printable for most customers - a sheet their printer
           has to shrink breaks the true-size guarantee the check ruler exists to prove. */
        ethical_deer: {
          targetStyle: 'single',
          paperSize: 'A4',
          orientation: 'portrait',
          gridSize: 29.09,            // 1 MOA at 100 m
          gridMode: 'moa-one',
          gridStrength: 'range',
          aimStyle: 'dot-only',
          aimSize: 20,
          distance: '100m',
          notes: '',
          showNotes: false,
          showGridLabels: false,
          gridLabelUnit: 'moa',
          markerMode: 'none',
          holdover: 'off',
          ethicalGame: 'deer',
          conditionsRow: false,
          moaRings: 0,
          multiPage: 1,
          pageTitle: 'DEER VITAL ZONE'
        },
        /* Custom — landscape, diamond hold point, MOA holdover, 5 mm grid,
           conditions header + lower data strip both on and visible.
           Page title locks to 'USER CUSTOM TARGET' so anything
           user-customised reads consistently regardless of the target style
           they picked. The auto-promote path in onUserChange also enforces
           this title when the user transitions from another preset. */
        custom: {
          targetStyle: 'diamond',
          paperSize: 'A4',
          orientation: 'landscape',
          gridSize: 5,
          gridStrength: 'field',
          aimStyle: 'crosshair',
          aimSize: 400,
          distance: '100m',
          notes: '',
          showNotes: true,
          showGridLabels: true,
          gridLabelUnit: 'moa',
          markerMode: 'auto',
          holdover: 'moa',
          ethicalGame: 'off',
          conditionsRow: true,
          moaRings: 999,
          multiPage: 1,
          pageTitle: 'USER CUSTOM TARGET'
        }
      };

      function root() {
        return document.getElementById(rootId);
      }

      function byId(name) {
        return document.getElementById(name + '-' + sectionId);
      }

      function forEachNode(nodeList, fn) {
        Array.prototype.forEach.call(nodeList || [], fn);
      }

      /* ── Custom preset persistence ─────────────────────────────────
         Saved Custom presets carry a `_v` field stamped with
         CUSTOM_SCHEMA_VERSION. At load time (loadCustomPreset, below),
         mismatched versions are silently wiped — users never see a
         stale save that crashes the UI or renders nonsense, and the
         next save writes a fresh preset at the current version.

         ── Schema (preset shape — keep this list in sync with the
            return value of buildPresetFromUI) ───────────────────────
         _v                Schema version stamp (number)
         targetStyle       'single' | 'diamond' | 'cold_bore' |
                           'zero_sheet' | 'multi_grid'
         paperSize         'A4' | 'A3' | 'LETTER' | 'TABLOID'
         orientation       'portrait' | 'landscape'
         gridSize          mm spacing ACTUALLY DRAWN (0 = no grid,
                           including an MOA grid suppressed because the
                           distance is unknown or too short to print)
         gridMode          'abs' | 'moa-quarter' | 'moa-half' | 'moa-one'
                           — how the user picked the spacing. 'abs' means
                           gridSize is the whole story; an MOA token means
                           gridSize was derived from the distance at save
                           time and must be re-derived on restore. Absent
                           in pre-v67 saves; treat as 'abs'.
         gridStrength      'field' | 'range'
         aimStyle          'dot-only' | 'crosshair' | 'hollow' |
                           'square-rotated' | 'cross-dot' | 't-circle' |
                           'diamond' | 'chevron' | 'x-mark' | 'box' |
                           'sticker-guide'
         aimSize           mm — canonical, always. See
                           getDisplayedAimSizeMm() — the UI may show
                           inches but storage is mm regardless of
                           unitSystem.
         distance          text, eg "100m" or "100yd"
         notes             text
         showNotes         bool
         showGridLabels    bool
         gridLabelUnit     'moa' | 'mil'
         rifle             text
         calibre           text
         markerMode        'none' | 'auto' | 'tt1'..'tt5'
         holdover          'off' | 'moa' | 'mil'
         ethicalGame       'off' | 'deer' | 'pig' | 'goat' |
                           'smallgame' | 'rodent'
         conditionsRow     bool
         sessionName       text
         unitSystem        'metric' | 'imperial' (display only — does
                           NOT change how aimSize / ethicalGame are
                           interpreted; they're always mm-based)
         multiGridLayout   '1x2' | '2x1' | '2x2' | '2x3' | '3x2' | '3x3'
         pageTitle         text or null
         moaRings          number (0 = off, >0 = on)

         ── Schema change checklist ──────────────────────────────────
         When you touch the saved preset shape, run through these:
           1. Update buildPresetFromUI() to read/write the field.
           2. Update applyPresetData() to consume it with a sensible
              default for old saves missing the field.
           3. Decide: is this BREAKING or ADDITIVE? (see below)
           4. If BREAKING: bump CUSTOM_SCHEMA_VERSION.
           5. Update the schema list above so it matches the new shape.
           6. Add a line to the version history below.

         ── Breaking vs additive ─────────────────────────────────────
         BREAKING (must bump CUSTOM_SCHEMA_VERSION):
           • Renaming a field — old saves carry the old name, new code
             reads the new name, semantic data is lost.
           • Changing a field's units or meaning — eg pre-v40 the
             aimSize input was treated as mm in metric AND imperial;
             if a hypothetical future change made it inches in
             imperial saves, that's breaking.
           • Changing a field's type or structure (number → object,
             string → array, etc.).
           • Removing a value from an enum that old saves might use
             without a graceful fallback.
           • Removing a field that applyPresetData depends on without
             a graceful default.

         ADDITIVE (no bump needed):
           • Adding a new field — old saves won't have it; ensure
             applyPresetData reads it with `if (preset.x !== undefined)`
             or `preset.x || defaultValue` patterns (already the
             prevailing style).
           • Adding a new value to an existing enum — old saves still
             carry valid values; users can opt into the new one.
           • Tightening a numeric range — old saves can be clamped on
             load without semantic loss.

         ── Version history ──────────────────────────────────────────
         v=1   implicit (no _v field). Pre-v31 saves had no version
               stamp; loadCustomPreset() treats undefined !== current
               as a mismatch and wipes them.
         v=2   v31 of terra-build. Introduced the _v stamp itself, and
               bumped to 2 to flush out a pre-v29 latent bug that was
               persisting aimSize=400 in some saves.

         No bumps from v32 → v44 — all changes have been UI-layer or
         draw-layer only; the schema fields and semantics have not
         moved. v40 introduced the unit-toggle UX but kept aimSize
         stored as mm regardless of display unit, so existing saves
         interpret correctly under new code without migration.

         v67 added MOA grid spacings and the gridMode field. ADDITIVE, so
         NO BUMP — gridSize keeps its documented units and meaning
         (millimetres, 0 = no grid), and old saves without gridMode read
         correctly as absolute. Redefining gridSize as an angle would
         have been BREAKING by the rules above, and the bump would have
         wiped every user's saved Custom preset for no benefit. */
      var CUSTOM_SCHEMA_VERSION = 2;

      function setCustomHasData(has) {
        var sel = byId('terra-preset-select');
        if (!sel) return;
        var opt = sel.querySelector('option[value="custom"]');
        if (!opt) return;
        opt.textContent = has ? 'Custom \u2022' : 'Custom';
      }

      function saveCustomPreset() {
        try {
          var config = buildPresetFromUI();
          config._v = CUSTOM_SCHEMA_VERSION;
          localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
          setCustomHasData(true);
        } catch (e) {}
      }

      function loadCustomPreset() {
        try {
          var stored = localStorage.getItem(STORAGE_KEY);
          if (!stored) return null;
          var parsed = JSON.parse(stored);
          /* Reject stale schema — the user won't see whatever we read,
             but they also won't see a bug-fingerprint preset. The
             console warning gives future maintainers visibility in
             devtools that a wipe happened (otherwise the user just
             sees their Custom dot disappear with no explanation). */
          if (!parsed || parsed._v !== CUSTOM_SCHEMA_VERSION) {
            if (typeof console !== 'undefined' && console.warn) {
              console.warn(
                '[terra-build] Discarding saved Custom preset: schema v=' +
                (parsed && parsed._v) + ', expected v=' + CUSTOM_SCHEMA_VERSION
              );
            }
            try { localStorage.removeItem(STORAGE_KEY); } catch (e2) {}
            return null;
          }
          setCustomHasData(true);
          return parsed;
        } catch (e) {
          return null;
        }
      }

      /* Wipe any saved Custom and reset the dropdown indicator. Exposed
         via the Reset Custom mini-button — gives users an in-app way
         out of stale-state lock-in without touching DevTools. */
      function clearCustomPreset() {
        try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
        setCustomHasData(false);
      }

      function buildPresetFromUI() {
        /* Resolve through the same function getConfig uses. This is the
           second read of the grid select and it feeds localStorage on
           every user change — if the two ever disagree, what gets saved
           stops matching what is drawn. gridSize persists the mm ACTUALLY
           DRAWN (0 when a MOA grid was suppressed) so it can never
           contradict gridMode. */
        var presetDistanceMetres = parseDistanceMetres(byId('terra-distance').value.trim(), getActiveUnit());
        var presetGrid = resolveGridSpacing(
          byId('terra-grid-size').value,
          isNaN(presetDistanceMetres) ? 0 : presetDistanceMetres
        );
        return {
          targetStyle: byId('terra-target-style').value,
          paperSize: byId('terra-paper-size').value,
          orientation: byId('terra-orientation').value,
          gridSize: presetGrid.mm,
          gridMode: presetGrid.mode,
          gridStrength: getActiveGridStrength(),
          aimStyle: getActiveAimStyle(),
          /* Aim size is ALWAYS persisted as mm regardless of the user's
             current display unit — see getDisplayedAimSizeMm() (v40). */
          aimSize: getDisplayedAimSizeMm(),
          distance: byId('terra-distance').value.trim(),
          notes: byId('terra-notes').value.trim(),
          showNotes: !!byId('terra-show-notes').checked,
          showGridLabels: !!byId('terra-show-grid-labels').checked,
          gridLabelUnit: byId('terra-grid-label-unit').value,
          rifle: byId('terra-rifle').value.trim(),
          calibre: byId('terra-calibre').value.trim(),
          markerMode: getActiveMarkerMode(),
          purpose: getActivePurpose(),
          holdover: getActiveHoldover(),
          ethicalGame: byId('terra-ethical-game').value,
          conditionsRow: !!byId('terra-conditions-row').checked,
          sessionName: byId('terra-session-name').value.trim(),
          unitSystem: getActiveUnit(),
          multiGridLayout: getActiveMultiGridLayout(),
          /* Preserve preset-level page title across customisation. */
          pageTitle: runtimeState.pageTitleOverride || null,
          /* Capture the user's actual MOA-rings toggle so their choice
             persists across reloads (was previously hardcoded to 0,
             which silently dropped any 'On' or 'Auto' override). */
          moaRings: resolveMoaRings()
        };
      }

      /* ── Paper helpers ── */
      function paperDimensions(size, orientation) {
        var dims;
        switch (size) {
          case 'A3':
            dims = { width: 297, height: 420 };
            break;
          case 'LETTER':
            dims = { width: 215.9, height: 279.4 };
            break;
          case 'TABLOID':
            dims = { width: 279.4, height: 431.8 };
            break;
          case 'A4':
          default:
            dims = { width: 210, height: 297 };
            break;
        }
        if (orientation === 'landscape') {
          return { width: dims.height, height: dims.width };
        }
        return dims;
      }

      function paperScaleFactor(size) {
        switch (size) {
          case 'A3':
          case 'TABLOID':
            return 1.16;
          case 'LETTER':
            return 0.95;
          case 'A4':
          default:
            return 1;
        }
      }

      /* ── SVG helpers ── */
      function createSvgNode(tag, attrs) {
        var node = document.createElementNS(svgNs, tag);
        Object.keys(attrs || {}).forEach(function(key) {
          node.setAttribute(key, attrs[key]);
        });
        if (['line', 'rect', 'circle', 'path', 'polyline', 'polygon'].indexOf(tag) !== -1 && !node.hasAttribute('vector-effect')) {
          node.setAttribute('vector-effect', 'non-scaling-stroke');
        }
        return node;
      }

      function clearNode(node) {
        while (node.firstChild) node.removeChild(node.firstChild);
      }

      function appendText(parent, attrs, text) {
        var node = createSvgNode('text', attrs || {});
        node.textContent = text;
        parent.appendChild(node);
        return node;
      }

      function addLine(parent, x1, y1, x2, y2, attrs) {
        var node = createSvgNode('line', Object.assign({ x1: x1, y1: y1, x2: x2, y2: y2 }, attrs || {}));
        parent.appendChild(node);
        return node;
      }

      function addRect(parent, x, y, width, height, attrs) {
        var node = createSvgNode('rect', Object.assign({ x: x, y: y, width: width, height: height }, attrs || {}));
        parent.appendChild(node);
        return node;
      }

      function addCircle(parent, cx, cy, r, attrs) {
        var node = createSvgNode('circle', Object.assign({ cx: cx, cy: cy, r: r }, attrs || {}));
        parent.appendChild(node);
        return node;
      }

      /* ── Grid spacing model: absolute mm vs angular MOA ──────────────
         Two kinds of grid live behind one <select>, and they are not the
         same kind of thing:

           ABSOLUTE  5 / 10 / 20 mm (metric), 1/4 / 1/2 / 1 in (imperial).
                     5 mm is 5 mm at any range. The value IS the spacing.
           ANGULAR   1/4 / 1/2 / 1 MOA. An angle, not a length. It only
                     becomes millimetres once you know the distance.

         1 MOA = 1/60 degree. tan(1/60 deg) x 1000 mm = 0.29088821 mm per
         metre of range, so 1 MOA @ 100 m = 29.09 mm, 1/2 MOA = 14.54 mm,
         1/4 MOA = 7.27 mm. That is the whole of the maths; everything
         below is about carrying the user's INTENT safely through code
         that has always assumed "the select's value is mm as a float".

         WHY THE OPTION VALUE IS AN OPAQUE TOKEN, NOT A COMPUTED mm FLOAT.
         Three independent traps, each of which silently downgrades a
         computed-mm option to a 10 mm grid with no error:
           1. Nothing rebuilds or re-labels the grid <select> when the
              distance changes — bind() wires the distance input to
              onUserChange -> render(), which never touches the select.
              A stored mm value goes stale on the first keystroke.
           2. refreshUnitDependentControls() destroys the option list on
              every unit toggle and preserves the selection by mm
              proximity within 0.1 mm. A distance-derived mm has no
              stable value to match on — measured drift for 1 MOA at
              1000 m through the lossy m/yd round trip below is
              0.1029 mm, i.e. outside the window, so the choice is lost.
           3. applyPresetData assigns String(preset.gridSize) to the
              select. An unmatched value leaves value === '' , which
              parseFloat turns into NaN, which both read sites turn into
              a silent 10 mm grid.
         A token ('moa-half') is stable under all three: it survives the
         rebuild by identity, it does not depend on distance, and it
         round-trips through String()/JSON unchanged.

         THE TOKEN MUST NOT START WITH A DIGIT, '.', '+' OR '-'.
         parseFloat is a PREFIX parser: '0.25moa' parses to 0.25 and would
         draw a 0.25 mm grid — roughly 800 lines across A4, a solid black
         rectangle that reads as a rendering bug rather than a config
         error. And '-0.25' is eaten by the Math.max(0, v) clamps in
         getConfig/buildPresetFromUI and becomes "no grid". 'moa-half'
         gives parseFloat -> NaN at every legacy site, which is the safe
         direction to fail.

         WHY THERE IS A FLOOR. An absolute option cannot misbehave: 5 mm
         is the finest we offer and it is 5 mm forever. A MOA spacing is
         inversely proportional to a free-text, unvalidated distance field
         that the user routinely passes through '10' and '1' while
         backspacing '100m' — and render() is synchronous with no
         debounce. Measured node counts for a 1/4 MOA grid on A4 portrait
         single-target: 54 lines at 100m, 550 at 10m, 5,514 at 1m, and
         551,418 at 0.01m. drawMultiGrid calls addGrid once per cell (x9
         on a 3x3) and printTarget clones the whole SVG per page. The
         floor sits BELOW the finest absolute option, so it can never
         refuse a grid that would otherwise have printed. Refusal
         thresholds: 1/4 MOA under 27.50 m, 1/2 MOA under 13.75 m,
         1 MOA under 6.88 m.

         WHY majorEvery IS PER-OPTION. The bold/labelled line was
         hardcoded to every 5th, which is a decimal convention. On a
         1/4 MOA grid that bolds at 1.25 MOA and labels it "1.3" (see
         formatGridLabel's toFixed(1)) — a wrong number on a sheet used
         to dial a scope. Whole-MOA emphasis is the point of the
         feature. */
      var MOA_MM_PER_METRE = 0.290888;
      var GRID_MIN_SPACING_MM = 2.0;
      /* Finest label pitch (spacing x majorEvery) that can still carry a
         readable number. Shared by addGridLabels, which stops drawing the
         axis numbers below it, and updateMoaReadout, which must not
         promise labels the drawing code has already suppressed. The two
         held the figure independently at first and did not line up,
         because they are reached through different quantities: the floor
         above gates the SPACING, this gates the spacing TIMES majorEvery.
         Measured band where a grid drew with no axis numbers while the
         readout still said "labelled every 1.00 MOA" — 1/2 MOA from
         13.75 m (floor) to 20.63 m (pitch), 1 MOA from 6.88 m to 10.31 m.
         1/4 MOA is immune: it is refused outright below 27.50 m, which is
         already past the 20.63 m where its labels start fitting. */
      var GRID_MIN_LABEL_PITCH_MM = 6;
      var GRID_MOA_OPTIONS = {
        'moa-quarter': { moa: 0.25, label: '1/4 MOA', majorEvery: 4 },
        'moa-half':    { moa: 0.5,  label: '1/2 MOA', majorEvery: 2 },
        'moa-one':     { moa: 1,    label: '1 MOA',   majorEvery: 2 }
      };
      /* Explicit order — the select is built from this, not from key
         enumeration, so the picker order is never at the mercy of the
         engine's property ordering. */
      var GRID_MOA_ORDER = ['moa-quarter', 'moa-half', 'moa-one'];

      /* The single place that knows MOA grids exist. Everything
         downstream keeps receiving plain mm, so addGrid, addGridLabels,
         convertMmToUnit, the QR payload and the print path need no idea
         this happened.

         Returns:
           mm          mm to actually draw. 0 means draw nothing.
           mode        'abs' or the token — this is what gets persisted.
           moa         chosen angle (0 for absolute).
           majorEvery  bold + label multiple, always >= 1.
           state       'off' | 'abs' | 'ok' | 'no-distance' | 'too-fine'
           label       '1/4 MOA' etc. for messages ('' for absolute).
           refusedMm   the spacing we declined to draw, so the readout
                       can name the number instead of just complaining.

         distanceMetres arrives already normalised through getConfig's
         `isNaN(d) ? 0 : d` sentinel, so this function has exactly ONE
         contract for "distance unknown": a non-positive number. */
      function resolveGridSpacing(selectValue, distanceMetres) {
        /* hasOwnProperty, not a bare lookup: a stale or hand-edited
           preset could carry gridMode 'constructor', which would come
           back truthy off the prototype and yield NaN spacing. */
        if (Object.prototype.hasOwnProperty.call(GRID_MOA_OPTIONS, selectValue)) {
          var moaOpt = GRID_MOA_OPTIONS[selectValue];
          var d = (typeof distanceMetres === 'number' && isFinite(distanceMetres))
            ? distanceMetres
            : 0;
          if (d <= 0) {
            return {
              mm: 0, mode: selectValue, moa: moaOpt.moa,
              majorEvery: moaOpt.majorEvery, state: 'no-distance',
              label: moaOpt.label, refusedMm: 0
            };
          }
          var mm = moaOpt.moa * d * MOA_MM_PER_METRE;
          if (mm < GRID_MIN_SPACING_MM) {
            return {
              mm: 0, mode: selectValue, moa: moaOpt.moa,
              majorEvery: moaOpt.majorEvery, state: 'too-fine',
              label: moaOpt.label, refusedMm: mm
            };
          }
          return {
            mm: mm, mode: selectValue, moa: moaOpt.moa,
            majorEvery: moaOpt.majorEvery, state: 'ok',
            label: moaOpt.label, refusedMm: 0
          };
        }

        /* Absolute branch — byte-for-byte the old behaviour, including
           the NaN -> 10 fallback and the negative clamp. */
        var v = parseFloat(selectValue);
        if (isNaN(v)) v = 10;
        v = Math.max(0, v);
        return {
          mm: v, mode: 'abs', moa: 0, majorEvery: 5,
          state: (v > 0) ? 'abs' : 'off', label: '', refusedMm: 0
        };
      }

      /* ── Grid drawing ── */
      function addGrid(parent, area, spacing, strength, origin, majorEvery) {
        /* Grid disabled — used by the "None (no grid)" dropdown option. */
        if (!spacing || spacing <= 0) return;
        var grid = createSvgNode('g', {
          'class': 'terra-grid',
          'shape-rendering': 'geometricPrecision'
        });
        var palette = strength === 'range'
          ? { minor: '#c3cec3', minorWidth: 0.42 }
          : { minor: '#aeb9ae', major: '#5f6f5f', minorWidth: 0.56, majorWidth: 1.02 };

        /* Every 5th line was hardcoded until MOA spacings arrived. It is
           still the default when the argument is absent, so any call site
           this change misses behaves exactly as before rather than
           drawing an all-minor grid. */
        var majorStep = (majorEvery > 0) ? majorEvery : 5;

        /* Anchor grid lines at the origin (aim point) when one is provided.
           This guarantees lines pass through the aim AND that any two
           areas with the same origin pattern produce identical relative
           grid layouts — critical for multi-aim grids where fractional
           cell.y values used to cause subtle per-cell drift in where the
           first grid line falls relative to the cell top.

           When origin isn't supplied, fall back to absolute spacing
           multiples (the legacy behaviour). */
        var hasOriginX = origin && typeof origin.x === 'number';
        var hasOriginY = origin && typeof origin.y === 'number';
        var originX = hasOriginX ? origin.x : Math.round((area.x + area.width / 2) / spacing) * spacing;
        var originY = hasOriginY ? origin.y : Math.round((area.y + area.height / 2) / spacing) * spacing;
        var startX = hasOriginX
          ? originX + Math.ceil((area.x - originX) / spacing) * spacing
          : Math.ceil(area.x / spacing) * spacing;
        var startY = hasOriginY
          ? originY + Math.ceil((area.y - originY) / spacing) * spacing
          : Math.ceil(area.y / spacing) * spacing;

        for (var x = startX; x <= area.x + area.width + 0.001; x += spacing) {
          var lineAttrs = {
            stroke: palette.minor,
            'stroke-width': palette.minorWidth,
            'vector-effect': 'non-scaling-stroke'
          };

          if (strength !== 'range') {
            var columnIndex = Math.round((x - originX) / spacing);
            if (Math.abs(columnIndex % majorStep) === 0) {
              lineAttrs.stroke = palette.major;
              lineAttrs['stroke-width'] = palette.majorWidth;
            }
          }

          addLine(grid, x, area.y, x, area.y + area.height, lineAttrs);
        }

        for (var y = startY; y <= area.y + area.height + 0.001; y += spacing) {
          var rowAttrs = {
            stroke: palette.minor,
            'stroke-width': palette.minorWidth,
            'vector-effect': 'non-scaling-stroke'
          };

          if (strength !== 'range') {
            var rowIndex = Math.round((y - originY) / spacing);
            if (Math.abs(rowIndex % majorStep) === 0) {
              rowAttrs.stroke = palette.major;
              rowAttrs['stroke-width'] = palette.majorWidth;
            }
          }

          addLine(grid, area.x, y, area.x + area.width, y, rowAttrs);
        }

        parent.appendChild(grid);
      }

      /* ── Grid unit labels (MOA / MIL) ── */
      function addGridLabels(parent, area, origin, spacing, distanceMetres, unit, labelEvery) {
        if (!distanceMetres || distanceMetres <= 0) return;
        if (!spacing || spacing <= 0) return; /* no grid → no labels */

        var labelGroup = createSvgNode('g', { 'class': 'terra-grid-labels' });
        var labelFontSize = Math.max(2.8, Math.min(3.6, spacing * 0.38));
        var labelColor = '#8a968a';

        /* Labels must land on the BOLD lines, so they share addGrid's
           multiple. Same default-to-5 rule for the same reason. */
        var majorStep = spacing * ((labelEvery > 0) ? labelEvery : 5);

        /* Overprint guard. labelFontSize floors at 2.8 mm and a "1.0"
           glyph run is ~4-5 mm wide, so below GRID_MIN_LABEL_PITCH_MM the
           axis degrades into an unreadable smear of overlapping numbers.
           Absolute options can never reach this — their finest pitch is
           5 x 5 = 25 mm — so existing output is untouched; only a MOA
           grid near the 2 mm floor trips it (e.g. 1/2 MOA at 2 mm
           spacing labels every 4 mm). The '0' origin label below still
           renders, because knowing where zero is stays useful even when
           the axis numbers cannot fit. */
        if (majorStep >= GRID_MIN_LABEL_PITCH_MM) {
          /* Each loop walks its coordinate by += majorStep for PLACEMENT
             but takes the label VALUE from the step index, because
             `x - origin.x` carries the drift of every += before it.
             Measured, 1/4 MOA at 100 m on A4: the first step came back
             as 29.088799999999992 mm instead of 29.0888, which
             convertMmToUnit turned into 0.9999999999999998 — under
             formatGridLabel's whole-number boundary by 2e-16, so the top
             axis printed "3.0  2.0  1.00  0  1.00  2.0  3.0". The sign of
             the drift follows the aim's coordinate, so a two-area layout
             printed "1.00" on one target and "1.0" on the other for the
             same 1 MOA. An absolute grid only lands on a bucket boundary
             at contrived distances; an MOA grid puts a label on a whole
             MOA at EVERY distance, so the one number this feature exists
             to show was the one formatted wrong.
             step * majorStep is a single product with nothing accumulated
             in it. The residual case — the division inside convertMmToUnit
             landing a hair short of a boundary — is absorbed by
             formatGridLabel's rounding-aware buckets. Placement keeps the
             walked coordinate; 1e-14 mm is not a thing paper can hold. */

          /* labels along top edge (horizontal axis) */
          var step = 1;
          for (var x = origin.x + majorStep; x <= area.x + area.width - 2; x += majorStep) {
            var val = convertMmToUnit(step * majorStep, distanceMetres, unit);
            appendText(labelGroup, {
              x: x,
              y: area.y - 1.2,
              'font-size': labelFontSize,
              'font-weight': '600',
              fill: labelColor,
              'text-anchor': 'middle'
            }, formatGridLabel(val, unit));
            step += 1;
          }
          var stepN = 1;
          for (var xn = origin.x - majorStep; xn >= area.x + 2; xn -= majorStep) {
            var valN = convertMmToUnit(stepN * majorStep, distanceMetres, unit);
            appendText(labelGroup, {
              x: xn,
              y: area.y - 1.2,
              'font-size': labelFontSize,
              'font-weight': '600',
              fill: labelColor,
              'text-anchor': 'middle'
            }, formatGridLabel(valN, unit));
            stepN += 1;
          }

          /* labels along left edge (vertical axis) */
          var stepV = 1;
          for (var y = origin.y + majorStep; y <= area.y + area.height - 2; y += majorStep) {
            var valV = convertMmToUnit(stepV * majorStep, distanceMetres, unit);
            appendText(labelGroup, {
              x: area.x - 1.5,
              y: y + labelFontSize * 0.35,
              'font-size': labelFontSize,
              'font-weight': '600',
              fill: labelColor,
              'text-anchor': 'end'
            }, formatGridLabel(valV, unit));
            stepV += 1;
          }
          var stepVN = 1;
          for (var yn = origin.y - majorStep; yn >= area.y + 2; yn -= majorStep) {
            var valVN = convertMmToUnit(stepVN * majorStep, distanceMetres, unit);
            appendText(labelGroup, {
              x: area.x - 1.5,
              y: yn + labelFontSize * 0.35,
              'font-size': labelFontSize,
              'font-weight': '600',
              fill: labelColor,
              'text-anchor': 'end'
            }, formatGridLabel(valVN, unit));
            stepVN += 1;
          }
        }

        /* origin label */
        appendText(labelGroup, {
          x: area.x - 1.5,
          y: origin.y + labelFontSize * 0.35,
          'font-size': labelFontSize,
          'font-weight': '700',
          fill: '#5f6f5f',
          'text-anchor': 'end'
        }, '0');

        parent.appendChild(labelGroup);
      }

      function convertMmToUnit(mm, distanceMetres, unit) {
        if (unit === 'mil') {
          return mm / distanceMetres;
        }
        return mm / (distanceMetres * MOA_MM_PER_METRE);
      }

      /* Buckets are chosen by what the number will PRINT as, not by its
         raw magnitude — hence 9.995 and 0.995 rather than 10 and 1.
         convertMmToUnit divides two independently rounded products, so a
         label that is meant to be exactly 10 MOA can arrive as
         9.999999999999998 and take the wrong branch. Feeding the loops
         an exact step index (see addGridLabels) removes the accumulated
         drift but not this: measured, 1 MOA at 12.1 m still landed the
         10 MOA label just short, printing an axis of
         "2.0 4.0 6.0 8.0 10.0 12". An MOA grid puts a label on a whole
         MOA at every distance, so these boundaries are not a rare case
         for it the way they are for a fixed-millimetre grid. */
      function formatGridLabel(value, unit) {
        if (value < 0.01) return '0';
        if (value >= 9.995) return value.toFixed(0);
        if (value >= 0.995) return value.toFixed(1);
        return value.toFixed(2);
      }

      /* Grid snapping removed v44. v36 made addGrid() anchor lines on the aim
         point, so snapToGridCrossing() became redundant, then harmful - it
         shifted a centred A4 aim 5mm left on a 20mm grid. Do not reintroduce
         without a user-visible toggle. */

      function constrainAimSizeToArea(area, aimPoint, desiredSize) {
        var edgeClearance = Math.min(
          aimPoint.x - area.x,
          area.x + area.width - aimPoint.x,
          aimPoint.y - area.y,
          area.y + area.height - aimPoint.y
        );

        var maxDiameter = Math.max((edgeClearance * 2) - 1.2, 10);
        return Math.min(desiredSize, maxDiameter);
      }

      /* ── Aim point drawing ── */
      function addAimPoint(parent, x, y, sizeMm, style, variant) {
        var g = createSvgNode('g', { transform: 'translate(' + x + ' ' + y + ')' });
        var outer = sizeMm * (variant === 'diamond' ? 0.95 : 1);
        var mid = outer * 0.62;
        var inner = Math.max(outer * 0.18, 1.6);
        var stroke = '#202420';
        var accent = '#c56d1f';
        var supportRadius = outer * 0.5;
        var squareOuter = outer * 0.76;
        var squareInner = squareOuter * 0.56;

        if (variant === 'diamond') {
          g.appendChild(createSvgNode('rect', {
            x: -outer / 2,
            y: -outer / 2,
            width: outer,
            height: outer,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.9,
            transform: 'rotate(45)'
          }));

          if (style === 'dot-only') {
            addCircle(g, 0, 0, inner, { fill: accent, stroke: stroke, 'stroke-width': 0.4 });
          } else if (style === 'crosshair') {
            addLine(g, -outer * 0.65, 0, outer * 0.65, 0, { stroke: stroke, 'stroke-width': 0.5 });
            addLine(g, 0, -outer * 0.65, 0, outer * 0.65, { stroke: stroke, 'stroke-width': 0.5 });
            addCircle(g, 0, 0, Math.max(inner * 0.35, 0.8), { fill: stroke });
          } else if (style === 'square-rotated') {
            g.appendChild(createSvgNode('rect', {
              x: -squareInner / 2,
              y: -squareInner / 2,
              width: squareInner,
              height: squareInner,
              fill: 'none',
              stroke: stroke,
              'stroke-width': 0.6,
              transform: 'rotate(90)'
            }));
            addCircle(g, 0, 0, Math.max(inner * 0.28, 0.8), { fill: stroke });
          } else {
            addCircle(g, 0, 0, Math.max(inner, 2.1), { fill: 'none', stroke: stroke, 'stroke-width': 0.6 });
          }

          parent.appendChild(g);
          return;
        }

        if (style === 'square-rotated') {
          g.appendChild(createSvgNode('rect', {
            x: -squareOuter / 2,
            y: -squareOuter / 2,
            width: squareOuter,
            height: squareOuter,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.8,
            transform: 'rotate(45)'
          }));
          g.appendChild(createSvgNode('rect', {
            x: -squareInner / 2,
            y: -squareInner / 2,
            width: squareInner,
            height: squareInner,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.5,
            transform: 'rotate(45)'
          }));
          addLine(g, -supportRadius * 0.72, 0, supportRadius * 0.72, 0, { stroke: stroke, 'stroke-width': 0.42, 'stroke-dasharray': '1.4 1.2' });
          addLine(g, 0, -supportRadius * 0.72, 0, supportRadius * 0.72, { stroke: stroke, 'stroke-width': 0.42, 'stroke-dasharray': '1.4 1.2' });
          addCircle(g, 0, 0, Math.max(inner * 0.34, 0.9), { fill: stroke });
          parent.appendChild(g);
          return;
        }

        /* ── Standalone-shape aim styles (no outer circle) ── */

        if (style === 'diamond') {
          /* Hollow diamond (rotated square outline) + small centre dot */
          var dHalf = outer * 0.40;
          g.appendChild(createSvgNode('polygon', {
            points: '0,' + (-dHalf) + ' ' + dHalf + ',0 0,' + dHalf + ' ' + (-dHalf) + ',0',
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.85,
            'stroke-linejoin': 'round'
          }));
          addCircle(g, 0, 0, Math.max(inner * 0.34, 0.9), { fill: stroke });
          parent.appendChild(g);
          return;
        }

        if (style === 'chevron') {
          /* Chevron pointing UP — apex sits AT the aim centre and the
             two arms extend down-and-outward. Putting the tip at (0,0)
             means the visible point of the reticle aligns exactly with
             the point of aim, and the body of the chevron sits below
             so it doesn't cover the target above the aim point. */
          var cHalfW = outer * 0.35;
          var cHeight = outer * 0.30;
          /* 1.0 -> 1.6mm for downrange visibility (see t-circle). */
          g.appendChild(createSvgNode('polyline', {
            points: (-cHalfW) + ',' + cHeight + ' 0,0 ' + cHalfW + ',' + cHeight,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 1.6,
            'stroke-linecap': 'round',
            'stroke-linejoin': 'round'
          }));
          parent.appendChild(g);
          return;
        }

        if (style === 'x-mark') {
          /* X — two diagonal lines crossing at the aim centre */
          var xHalf = outer * 0.30;
          /* 0.95 -> 1.5mm for downrange visibility (see t-circle). */
          addLine(g, -xHalf, -xHalf, xHalf, xHalf, {
            stroke: stroke,
            'stroke-width': 1.5,
            'stroke-linecap': 'round'
          });
          addLine(g, -xHalf, xHalf, xHalf, -xHalf, {
            stroke: stroke,
            'stroke-width': 1.5,
            'stroke-linecap': 'round'
          });
          parent.appendChild(g);
          return;
        }

        if (style === 'box') {
          /* Hollow square (axis-aligned, not rotated) + small centre dot */
          var bHalf = outer * 0.30;
          g.appendChild(createSvgNode('rect', {
            x: -bHalf,
            y: -bHalf,
            width: bHalf * 2,
            height: bHalf * 2,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.85,
            'stroke-linejoin': 'round'
          }));
          addCircle(g, 0, 0, Math.max(inner * 0.34, 0.9), { fill: stroke });
          parent.appendChild(g);
          return;
        }

        if (style === 'sticker-guide') {
          /* Full-size sticker placement guide. Unlike `box`, the outline is
             drawn at 100% of `outer` so a 80 mm aim size produces an exact
             80 × 80 mm box — sized to a real sticker product.

             Visual design (matches print-shop registration marks):
             - dashed perimeter so the shooter sees the bounds clearly
             - solid L-shaped corner ticks for precise registration
             - small solid centre crosshair for the aim point itself
             Once the sticker is placed, perimeter and corners disappear
             under it; the centre cross was only ever a placement aid. */
          var sHalf = outer / 2;
          /* Dashed perimeter */
          g.appendChild(createSvgNode('rect', {
            x: -sHalf, y: -sHalf,
            width: outer, height: outer,
            fill: 'none',
            stroke: stroke,
            'stroke-width': 0.45,
            'stroke-dasharray': '2.4 1.8'
          }));
          /* Solid L-shaped corner registration ticks.
             Tick leg = 8 % of size, capped at 7 mm so a 200 mm box doesn't
             grow unwieldy ticks. */
          var tick = Math.min(outer * 0.08, 7);
          var cornerW = 0.85;
          /* TL */
          addLine(g, -sHalf, -sHalf, -sHalf + tick, -sHalf, { stroke: stroke, 'stroke-width': cornerW });
          addLine(g, -sHalf, -sHalf, -sHalf, -sHalf + tick, { stroke: stroke, 'stroke-width': cornerW });
          /* TR */
          addLine(g,  sHalf, -sHalf,  sHalf - tick, -sHalf, { stroke: stroke, 'stroke-width': cornerW });
          addLine(g,  sHalf, -sHalf,  sHalf, -sHalf + tick, { stroke: stroke, 'stroke-width': cornerW });
          /* BL */
          addLine(g, -sHalf,  sHalf, -sHalf + tick,  sHalf, { stroke: stroke, 'stroke-width': cornerW });
          addLine(g, -sHalf,  sHalf, -sHalf,  sHalf - tick, { stroke: stroke, 'stroke-width': cornerW });
          /* BR */
          addLine(g,  sHalf,  sHalf,  sHalf - tick,  sHalf, { stroke: stroke, 'stroke-width': cornerW });
          addLine(g,  sHalf,  sHalf,  sHalf,  sHalf - tick, { stroke: stroke, 'stroke-width': cornerW });
          /* Centre crosshair (small + at the geometric centre) */
          var cross = Math.min(outer * 0.05, 4.5);
          addLine(g, -cross, 0, cross, 0, { stroke: stroke, 'stroke-width': 0.7, 'stroke-linecap': 'round' });
          addLine(g, 0, -cross, 0, cross, { stroke: stroke, 'stroke-width': 0.7, 'stroke-linecap': 'round' });
          parent.appendChild(g);
          return;
        }

        /* ── Outer-circle-framed aim styles ──
           dot-only, crosshair, hollow, cross-dot, t-circle */
        addCircle(g, 0, 0, outer / 2, { fill: 'none', stroke: stroke, 'stroke-width': 0.75 });

        /* Mid ring only on the styles that use it (legacy behaviour) */
        if (style === 'crosshair' || style === 'hollow') {
          addCircle(g, 0, 0, mid / 2, { fill: 'none', stroke: stroke, 'stroke-width': 0.45 });
        }

        if (style === 'dot-only') {
          addCircle(g, 0, 0, inner, { fill: accent, stroke: stroke, 'stroke-width': 0.4 });
        } else if (style === 'crosshair') {
          addLine(g, -outer * 0.72, 0, outer * 0.72, 0, { stroke: stroke, 'stroke-width': 0.45, 'stroke-dasharray': '1.5 1.2' });
          addLine(g, 0, -outer * 0.72, 0, outer * 0.72, { stroke: stroke, 'stroke-width': 0.45, 'stroke-dasharray': '1.5 1.2' });
          addCircle(g, 0, 0, Math.max(inner * 0.45, 0.9), { fill: stroke });
        } else if (style === 'cross-dot') {
          /* Solid (not dashed) cross + bigger centre dot — precision sight picture */
          addLine(g, -outer * 0.40, 0, outer * 0.40, 0, {
            stroke: stroke,
            'stroke-width': 0.80,
            'stroke-linecap': 'round'
          });
          addLine(g, 0, -outer * 0.40, 0, outer * 0.40, {
            stroke: stroke,
            'stroke-width': 0.80,
            'stroke-linecap': 'round'
          });
          addCircle(g, 0, 0, Math.max(inner * 0.55, 1.1), { fill: stroke });
        } else if (style === 't-circle') {
          /* T shape inside outer circle — horizontal cap centred ON the
             point of aim, vertical leg extending straight down from it.
             The cap doubles as a fine horizontal sight reference at the
             aim height; the leg below gives a vertical reference without
             obscuring anything above the aim point. */
          var tHalfW = outer * 0.22;
          var tCapY = 0;                  /* cap sits on aim centre */
          var tLegBot = outer * 0.38;     /* leg extends down (same 0.38 total length as before) */
          /* 0.80 -> 1.4mm: at 100m+ through a scope a 0.8mm line is ~0.03 MOA
             and effectively disappears. Same reason as chevron/x-mark. */
          /* Horizontal cap */
          addLine(g, -tHalfW, tCapY, tHalfW, tCapY, {
            stroke: stroke,
            'stroke-width': 1.4,
            'stroke-linecap': 'round'
          });
          /* Vertical leg */
          addLine(g, 0, tCapY, 0, tLegBot, {
            stroke: stroke,
            'stroke-width': 1.4,
            'stroke-linecap': 'round'
          });
        } else {
          /* hollow */
          addCircle(g, 0, 0, Math.max(inner, 2.2), { fill: 'none', stroke: stroke, 'stroke-width': 0.55 });
        }

        parent.appendChild(g);
      }

      /* ── Reference markers (Terra-Impact compatible V2) ──
         Each corner marker has a unique visual pattern so the detector can
         identify corner position. The 5 mm centre hole gives Terra-Impact
         a clean sub-pixel centroid target for fine-tune adjustments.

         Layout (20 × 20 mm total):
         - Black fill across whole marker
         - 10 × 10 mm white square positioned in the quadrant FACING the
           target centre (inward)
         - 5 mm diameter white circle dead-centre of the marker — sits on
           the black/white quadrant boundary, making it easy to find
           sub-pixel centre regardless of corner orientation

         cornerType: 'tl' | 'tr' | 'br' | 'bl' — refers to which corner of
         the target this marker sits in.
      */
      function addReferenceMarker(parent, cx, cy, cornerType) {
        var size = MARKER_SIZE_MM;
        var half = size / 2;
        var g = createSvgNode('g', { transform: 'translate(' + cx + ' ' + cy + ')' });

        /* Full 20 × 20 mm black background */
        g.appendChild(createSvgNode('rect', {
          x: -half, y: -half, width: size, height: size,
          fill: '#000000', stroke: 'none'
        }));

        /* Determine white-square quadrant (facing target centre) */
        var squareX, squareY;
        switch (cornerType) {
          case 'tl':
            squareX = 0;     squareY = 0;     /* bottom-right of marker */
            break;
          case 'tr':
            squareX = -half; squareY = 0;     /* bottom-left of marker */
            break;
          case 'br':
            squareX = -half; squareY = -half; /* top-left of marker */
            break;
          case 'bl':
            squareX = 0;     squareY = -half; /* top-right of marker */
            break;
          default:
            squareX = 0;     squareY = 0;
        }

        /* 10 × 10 mm white square — inward-facing quadrant */
        g.appendChild(createSvgNode('rect', {
          x: squareX, y: squareY, width: half, height: half,
          fill: '#ffffff', stroke: 'none'
        }));

        /* 5 mm diameter white circle at dead-centre of the marker —
           this is the sub-pixel detection target for Terra-Impact */
        g.appendChild(createSvgNode('circle', {
          cx: 0, cy: 0, r: 2.5,
          fill: '#ffffff', stroke: 'none'
        }));

        parent.appendChild(g);
      }

      /* Pick the largest marker preset that fits the grid area, leaving room
         for the aim point and grid margins. Returns preset key or null.
         When `requiredAimMm` is provided, also rejects spacings that would
         force the aim smaller than the requested diameter — used by
         sticker-guide aims where the box size is a physical reference and
         must not be clamped. */
      function resolveBestFitMarker(area, requiredAimMm) {
        for (var i = 0; i < MARKER_ORDER_LARGE_FIRST.length; i += 1) {
          var key = MARKER_ORDER_LARGE_FIRST[i];
          /* Page codes are placed by resolvePageMarker(), never fitted into an area. */
          if (isPageMarkerKey(key)) continue;
          if (markerFitsArea(area, markerPresetXY(MARKER_PRESETS[key]), requiredAimMm)) return key;
        }
        return null;
      }

      /* `sp` is an {x, y} spacing pair. Each axis is checked against its own
         page dimension - a square check against the smaller dimension would
         reject TT6/TT7 on pages where they genuinely fit. */
      function markerFitsArea(area, sp, requiredAimMm) {
        if (!sp) return false;
        /* Marker footprint: spacing (centre-to-centre) + MARKER_SIZE (outer edges).
           Leave at least 4 mm inside the grid area on all sides so markers
           don't push against the header/footer. */
        if (area.width  < sp.x + MARKER_SIZE_MM + 6) return false;
        if (area.height < sp.y + MARKER_SIZE_MM + 6) return false;
        /* When a specific aim size must coexist with the markers, the
           same byMarker formula in computeMaxAimForArea applies as the
           upper bound: aim diameter ≤ spacing − MARKER_SIZE − 4. Reject
           the spacing if it would force the aim smaller than required.
           The AIM IS ROUND, so the tighter axis governs. */
        if (requiredAimMm && requiredAimMm > 0) {
          var maxAimAtThisSpacing = (Math.min(sp.x, sp.y) - MARKER_SIZE_MM) - 4;
          if (maxAimAtThisSpacing < requiredAimMm) return false;
        }
        return true;
      }

      /* Returns an {x, y} pair, or null when the mode is off / cannot fit. */
      function resolveMarkerSpacing(mode, area, requiredAimMm) {
        if (!mode || mode === 'none') return null;
        if (mode === 'auto') {
          var best = resolveBestFitMarker(area, requiredAimMm);
          return best ? markerPresetXY(MARKER_PRESETS[best]) : null;
        }
        /* An explicit page code never goes in-area; resolvePageMarker() owns it. */
        if (isPageMarkerKey(mode)) return null;
        var sp = markerPresetXY(MARKER_PRESETS[mode]);
        if (!sp) return null;
        if (!markerFitsArea(area, sp, requiredAimMm)) return null;
        return sp;
      }

      /* Draw 4 corner markers centred around the target's aim point,
         spaced at the given centre-to-centre distance in mm. Each corner
         gets its own orientation-specific V2 pattern. */
      function addReferenceMarkersAround(parent, area, aimPoint, sp) {
        if (!sp) return;
        /* Per-axis halves: square presets give halfX === halfY as before,
           rectangular ones spread wider than they are tall (or vice versa).
           The markers MUST stay centred on the aim point - Terra-Confirm
           takes the centre of the rectified marker rectangle as the point of
           aim (aimX = canvas.width/2), so any offset between the two silently
           biases every POI reading by that amount. */
        var halfX = sp.x / 2, halfY = sp.y / 2;
        var cxL = aimPoint.x - halfX;
        var cxR = aimPoint.x + halfX;
        var cyT = aimPoint.y - halfY;
        var cyB = aimPoint.y + halfY;

        /* Safety clamp — keep markers strictly inside the grid area */
        var inset = MARKER_SIZE_MM / 2 + 1;
        if (cxL < area.x + inset) cxL = area.x + inset;
        if (cxR > area.x + area.width - inset) cxR = area.x + area.width - inset;
        if (cyT < area.y + inset) cyT = area.y + inset;
        if (cyB > area.y + area.height - inset) cyB = area.y + area.height - inset;

        addReferenceMarker(parent, cxL, cyT, 'tl');
        addReferenceMarker(parent, cxR, cyT, 'tr');
        addReferenceMarker(parent, cxL, cyB, 'bl');
        addReferenceMarker(parent, cxR, cyB, 'br');
      }

      /* ── MOA rings (concentric rings at integer MOA radii) ──
         Used by 100m Zero preset to give the shooter an at-a-glance ring
         count that corresponds directly to MOA at the set distance. */
      function addMoaRings(parent, area, aimPoint, config) {
        var count = config.moaRings | 0;
        if (count <= 0) return;
        if (!config.distanceMetres || config.distanceMetres <= 0) return;

        /* Use MOA by default, even if grid labels are MIL */
        var unitMmPerValue = (config.gridLabelUnit === 'mil')
          ? config.distanceMetres           /* mil → mm per 1 mil at range */
          : config.distanceMetres * MOA_MM_PER_METRE; /* MOA → mm per 1 MOA */

        var unitLabel = config.gridLabelUnit === 'mil' ? 'MIL' : 'MOA';

        /* Furthest area corner from the aim point — the largest radius that
           still has *any* portion inside the area. Rings up to this radius
           get drawn; the clipPath below crops anything past the edges, so
           partial rings appear as arcs at the page/grid borders.
           This deliberately ignores reference markers — rings render through
           them at full radius, then markers (drawn later, see drawZeroSheet)
           overlay the ring lines they cross. */
        var dxMax = Math.max(aimPoint.x - area.x, area.x + area.width - aimPoint.x);
        var dyMax = Math.max(aimPoint.y - area.y, area.y + area.height - aimPoint.y);
        var maxCornerR = Math.sqrt(dxMax * dxMax + dyMax * dyMax);

        /* Unique clipPath id per call so multi-grid cells (each with their
           own area) don't collide with the zero-sheet's clip rect. */
        var clipId = 'terra-moa-clip-'
                   + Math.round(area.x) + '-'
                   + Math.round(area.y) + '-'
                   + Math.round(area.width) + 'x'
                   + Math.round(area.height);
        var clipPathNode = createSvgNode('clipPath', { id: clipId });
        clipPathNode.appendChild(createSvgNode('rect', {
          x: area.x, y: area.y, width: area.width, height: area.height
        }));
        parent.appendChild(clipPathNode);

        var g = createSvgNode('g', {
          'class': 'terra-moa-rings',
          'clip-path': 'url(#' + clipId + ')'
        });

        /* Labels are anchored at 45° upper-right of each ring. Skip any
           label whose anchor would fall outside (or within `labelMargin` of)
           the area edge — clipping them mid-character looks broken, and
           large rings simply forfeit their label rather than render half. */
        var labelMargin = 4;

        /* DIAMETER convention (Greg's call, 2026-08-07): a ring labelled
           "2 MOA" measures 2 MOA ACROSS, so its radius is half that. This is
           the group-size reading shooters actually use ("a 1 MOA group").

           It is deliberately NOT the convention the GRID labels use - those
           read RADIAL OFFSET from the aim point, because that is what you
           dial into a turret. Two different questions answered on one sheet,
           which is exactly why every ring now carries its unit (see below):
           at 100 m a shot sitting on the "2 MOA" ring is 29.09 mm out and
           reads 1.0 on the grid axis. Both are correct; neither is guessable
           from a bare number. */
        var ringRadiusPerUnit = unitMmPerValue / 2;

        /* Halving the radius doubles how many rings fit, and at short range
           that turns the page grey - 1 MOA at 12.1 m is 3.52 mm across, which
           would be 84 dashed circles. Stride out so drawn rings stay >= 6 mm
           apart; labels still carry the TRUE MOA value, so the sheet thins out
           without ever lying about what a ring is. */
        var MIN_RING_PITCH_MM = 6;
        var stride = Math.max(1, Math.ceil(MIN_RING_PITCH_MM / ringRadiusPerUnit));

        for (var i = stride; i <= count; i += stride) {
          var r = i * ringRadiusPerUnit;
          if (r > maxCornerR) break;

          /* Subtly thicker line on every major (5-unit) ring */
          var isMajor = (i % 5 === 0);
          addCircle(g, aimPoint.x, aimPoint.y, r, {
            fill: 'none',
            stroke: isMajor ? '#5f6f5f' : '#8a968a',
            'stroke-width': isMajor ? 0.55 : 0.32,
            'stroke-dasharray': isMajor ? '3 1.5' : '1.6 1.4'
          });

          /* Small label on each ring at 45° upper-right (only if it fits) */
          var lx = aimPoint.x + r * 0.71;
          var ly = aimPoint.y - r * 0.71;
          if (lx >= area.x + labelMargin &&
              lx <= area.x + area.width - labelMargin &&
              ly >= area.y + labelMargin &&
              ly <= area.y + area.height - labelMargin) {
            appendText(g, {
              x: lx + 1,
              y: ly - 0.5,
              'font-size': 2.6,
              'font-weight': isMajor ? '800' : '700',
              fill: isMajor ? '#5f6f5f' : '#8a968a'
            /* EVERY ring carries its unit, not just the majors. The unit used
               to print only on every 5th ring, and at 100 m an A4 fits about
               five - so the first labelled ring was the last one drawn, and if
               its label failed the fit test above the sheet printed a bare
               "1 2 3 4" with nothing saying MOA. At 200 m you got "1 2"; at
               300 yd a single "1". The longer the shot, the more certain the
               sheet was to carry no unit at all. */
            }, i + ' ' + unitLabel);
          }
        }

        parent.appendChild(g);
      }

      /* Max aim diameter within the target area, respecting markers if present.
         Used for both dynamic slider bounds and final clipping. */
      function computeMaxAimForArea(area, markerSpacing) {
        var padding = 6; /* mm, leaves room for grid labels */
        var byCell = Math.min(area.width, area.height) - padding * 2;
        var byMarker = Infinity;
        if (markerSpacing) {
          /* Aim point must not overlap inner edges of markers.
             Inner edge distance from aim centre = (spacing/2) - MARKER_SIZE/2.
             Multiply by 2 for diameter, leave 4 mm clearance.
             The aim is a CIRCLE, so on a rectangular grid the short axis is
             the binding one. */
          byMarker = (Math.min(markerSpacing.x, markerSpacing.y) - MARKER_SIZE_MM) - 4;
        }
        return Math.max(10, Math.min(byCell, byMarker));
      }

      /* Resolve the aim size and marker spacing together.

         For most aim styles the resolution is "markers first, aim shrinks
         to fit": pick the largest TT preset that fits the area, then size
         the aim around it. The user's slider is treated as a "max desired"
         hint that gets clipped down if needed.

         For sticker-guide aims (Splatter Target preset) the priority is
         inverted: the aim is a physical reference (the splatter sticker is
         exactly aimSize mm) and must NOT shrink. Markers are auto-selected
         to fit alongside the locked aim, or dropped if no preset can
         coexist with it. This keeps the printed 80 mm box matching the
         real-world sticker on every paper / orientation combination. */
      function resolveAimAndMarker(area, aimPoint, config) {
        var stickerLocked = (config.aimStyle === 'sticker-guide');

        if (stickerLocked) {
          /* 1. Lock the aim size — area constraint only, no marker clamp. */
          var byCellOnly = Math.min(area.width, area.height) - 12; /* 6 mm padding each side */
          var desiredAim = Math.min(config.scaledAimSize, byCellOnly);
          var effectiveAimSize = constrainAimSizeToArea(area, aimPoint, desiredAim);
          /* 2. Pick markers that fit the area AND don't conflict with the
             locked aim. Returns null if no preset can coexist. */
          var markerSpacing = resolveMarkerSpacing(config.markerMode, area, effectiveAimSize);
          return {
            markerSpacing: markerSpacing,
            maxAim: effectiveAimSize,
            effectiveAim: effectiveAimSize
          };
        }

        /* Standard flow: markers chosen for the area, aim shrinks to fit. */
        var markerSpacingStd = resolveMarkerSpacing(config.markerMode, area);
        var maxAimStd = computeMaxAimForArea(area, markerSpacingStd);
        var desiredAimStd = Math.min(config.scaledAimSize, maxAimStd);
        var effectiveAimStd = constrainAimSizeToArea(area, aimPoint, desiredAimStd);
        return {
          markerSpacing: markerSpacingStd,
          maxAim: maxAimStd,
          effectiveAim: effectiveAimStd
        };
      }

      /* ── Holdover ladder ──
         Vertical tick marks below the aim point at 2, 4, 6, 8 units
         (MOA or MIL), scaled to the current shooting distance. */
      function addHoldoverLadder(parent, area, aimPoint, config) {
        if (!config.holdover || config.holdover === 'off') return;
        if (!config.distanceMetres || config.distanceMetres <= 0) return;

        var unit = config.holdover; /* 'moa' or 'mil' */
        var unitLabel = unit === 'mil' ? 'MIL' : 'MOA';
        var unitMmPerValue = (unit === 'mil')
          ? config.distanceMetres                /* mil → mm per 1 mil */
          : config.distanceMetres * MOA_MM_PER_METRE; /* MOA → mm per 1 MOA */

        /* Available drop below the aim point — total room for the ladder. */
        var maxDrop = (area.y + area.height - 4) - aimPoint.y;
        if (maxDrop <= 0) return;
        var maxUnits = maxDrop / unitMmPerValue;
        /* Minimum threshold is unit-specific: 0.5 MOA at 100 m is ~14 mm
           drop (worth showing); 0.5 MIL at 100 m is 50 mm drop (huge). For
           MIL the "useful smallest" is more like 0.1. */
        var minUsefulUnits = (unit === 'mil') ? 0.1 : 0.5;
        if (maxUnits < minUsefulUnits) return;

        /* Adaptive step — pick the LARGEST candidate that still gives at
           least 3 visible ticks. Bias toward whole-unit increments
           (shooters prefer them) on tall pages, falling back to fractional
           values only when whole units are too coarse.

           MIL candidates start smaller because each MIL is ~3.4× a MOA
           (1 MIL = 100 mm at 100 m vs 1 MOA = 29 mm at 100 m), so on the
           same page MOA gets to use big values like 5 / 2 / 1 while MIL
           realistically tops out around 1 and most often lands at 0.25 or
           0.1. Without unit-specific candidates the old [5,2,1,0.5,0.25]
           list left MIL mode with at most 2 ticks on A4 landscape. */
        var candidateSteps = (unit === 'mil')
          ? [2, 1, 0.5, 0.25, 0.1]
          : [5, 2, 1, 0.5, 0.25];
        var step = candidateSteps[candidateSteps.length - 1];
        for (var ci = 0; ci < candidateSteps.length; ci += 1) {
          if (Math.floor(maxUnits / candidateSteps[ci]) >= 3) {
            step = candidateSteps[ci];
            break;
          }
        }

        /* Generate up to 8 ticks at multiples of `step`, capped by maxUnits. */
        var stepValues = [];
        for (var n = 1; n <= 8 && n * step <= maxUnits; n += 1) {
          stepValues.push(n * step);
        }
        if (stepValues.length === 0) return;

        var g = createSvgNode('g', { 'class': 'terra-holdover-ladder' });
        var tickColor = '#a84d24';
        var tickWidth = 0.55;

        for (var i = 0; i < stepValues.length; i += 1) {
          var units = stepValues[i];
          var mmDrop = units * unitMmPerValue;
          var y = aimPoint.y + mmDrop;

          /* Horizontal tick line */
          var tickLen = Math.min(area.width * 0.08, 14);
          addLine(g, aimPoint.x - tickLen, y, aimPoint.x + tickLen, y, {
            stroke: tickColor,
            'stroke-width': tickWidth,
            'stroke-dasharray': '2 1'
          });

          /* Format label: integer when step is integer, trimmed decimal otherwise */
          var unitsLabel = (Math.abs(units - Math.round(units)) < 0.001)
            ? String(Math.round(units))
            : units.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');

          /* Label on the right */
          appendText(g, {
            x: aimPoint.x + tickLen + 1.5,
            y: y + 1.4,
            'font-size': 3.6,
            'font-weight': '700',
            fill: tickColor
          }, '\u2212' + unitsLabel + ' ' + unitLabel);
        }

        /* Tiny vertical connector from aim point down to first tick */
        addLine(g, aimPoint.x, aimPoint.y, aimPoint.x, aimPoint.y + 2, {
          stroke: tickColor,
          'stroke-width': 0.35,
          'stroke-dasharray': '0.6 0.8'
        });

        parent.appendChild(g);
      }

      /* ── Ethical-range visualiser ──
         Scaled vital-zone rings. Shows, at the CURRENT shooting distance,
         how a 2 MOA / 3 MOA / 4 MOA group would project onto the vital
         zone of the chosen game animal. If the rifle's group exceeds the
         outer ring, the shot is outside the vitals at that range. */
      var ETHICAL_GAME = {
        deer:      { label: 'Deer',       vitalsMm: 200 },
        pig:       { label: 'Pig',        vitalsMm: 150 },
        goat:      { label: 'Goat',       vitalsMm: 150 },
        smallgame: { label: 'Small game', vitalsMm:  75 },
        rodent:    { label: 'Rodent',     vitalsMm:  25 }
      };

      function addEthicalRangeRings(parent, area, aimPoint, config) {
        if (!config.ethicalGame || config.ethicalGame === 'off') return;
        var game = ETHICAL_GAME[config.ethicalGame];
        if (!game) return;

        var vitalsR = game.vitalsMm / 2;

        /* Skip silently if there's no meaningful room around the aim point
           (eg the area is tiny or the aim is jammed in a corner). */
        var minClearance = Math.min(
          aimPoint.x - area.x,
          area.x + area.width - aimPoint.x,
          aimPoint.y - area.y,
          area.y + area.height - aimPoint.y
        );
        if (minClearance < 8) return;

        /* Render at the ACTUAL vital-zone radius — do not scale the rings
           down to fit the page. The whole point of the overlay is to show
           real-size vital zones (200 mm deer, 150 mm pig / goat, 75 mm
           small game) so the shooter can read their group size against
           them. Clamping to fit the area would make eg deer and pig
           render at the same diameter on A4 landscape and defeat the
           comparison. If the ring overflows the page, the clipPath below
           crops it at the area edges — same pattern used by the MOA rings. */
        var outerR = vitalsR;
        var midR = vitalsR * 0.66;
        var innerR = vitalsR * 0.33;

        /* Unique clipPath id per call so multi-grid cells don't collide
           with the zero sheet / single target. */
        var clipId = 'terra-ethical-clip-'
                   + Math.round(area.x) + '-'
                   + Math.round(area.y) + '-'
                   + Math.round(area.width) + 'x'
                   + Math.round(area.height);
        var clipPathNode = createSvgNode('clipPath', { id: clipId });
        clipPathNode.appendChild(createSvgNode('rect', {
          x: area.x, y: area.y, width: area.width, height: area.height
        }));
        parent.appendChild(clipPathNode);

        var g = createSvgNode('g', {
          'class': 'terra-ethical-rings',
          'clip-path': 'url(#' + clipId + ')'
        });

        /* Vital-zone outer boundary */
        addCircle(g, aimPoint.x, aimPoint.y, outerR, {
          fill: 'none',
          stroke: '#c54a2a',
          'stroke-width': 0.7,
          'stroke-dasharray': '3 2'
        });
        /* Mid & inner rings (lighter) */
        addCircle(g, aimPoint.x, aimPoint.y, midR, {
          fill: 'none',
          stroke: '#c57a4a',
          'stroke-width': 0.42,
          'stroke-dasharray': '1.8 1.6'
        });
        addCircle(g, aimPoint.x, aimPoint.y, innerR, {
          fill: 'none',
          stroke: '#d89c6a',
          'stroke-width': 0.35,
          'stroke-dasharray': '1.2 1.4'
        });

        /* Label position: try outer-ring 45° upper-right first, then mid,
           then inner. SVG text doesn't degrade gracefully when clipped
           mid-glyph — falling back to a smaller ring's anchor keeps the
           label fully inside the area or skips it entirely. */
        var labelMargin = 4;
        function fitAt(r) {
          var lx = aimPoint.x + r * 0.71;
          var ly = aimPoint.y - r * 0.71;
          if (lx >= area.x + labelMargin &&
              lx <= area.x + area.width - labelMargin &&
              ly >= area.y + labelMargin &&
              ly <= area.y + area.height - labelMargin) {
            return { x: lx, y: ly };
          }
          return null;
        }
        var labelPos = fitAt(outerR) || fitAt(midR) || fitAt(innerR);
        if (labelPos) {
          appendText(g, {
            x: labelPos.x + 1,
            y: labelPos.y - 0.5,
            'font-size': 3.4,
            'font-weight': '800',
            fill: '#c54a2a'
          }, game.label.toUpperCase() + ' ' + game.vitalsMm + 'mm');
        }

        parent.appendChild(g);
      }

      /* ── Conditions row ──
         Small header band for temp / pressure / wind / RH, below the
         main brand header. Useful to hunters who record conditions before
         firing (not after, unlike the lower data strip). */
      /* y comes from the caller: the band moved to the foot of the page and
         its position now depends on the bottom stack, not the header. It was
         hardcoded 34.5 (below the PORTRAIT divider at y=34), which on
         landscape - divider at 24, content from 37 - dropped the band 4.5mm
         INTO the grid. Moving it down retires that. */
      function addConditionsRow(svg, dims, y, inset) {
        var rowH = 7;
        var fields = ['TEMP °C', 'PRESS hPa', 'WIND m/s', 'RH %', 'LIGHT'];
        var widths = [0.20, 0.20, 0.22, 0.18, 0.20];
        var edge = inset || 12;
        var x = edge;
        var totalW = dims.width - edge * 2;

        for (var i = 0; i < fields.length; i += 1) {
          var w = totalW * widths[i];
          addRect(svg, x, y, w, rowH, {
            fill: 'none',
            stroke: '#d6ddd3',
            'stroke-width': 0.35
          });
          appendText(svg, {
            x: x + 2,
            y: y + 3.2,
            'font-size': 2.8,
            'font-weight': '800',
            fill: '#5f695f',
            'letter-spacing': '0.04em'
          }, fields[i]);
          addLine(svg, x + 2, y + rowH - 1.6, x + w - 2, y + rowH - 1.6, {
            stroke: '#c8d0c6',
            'stroke-width': 0.22,
            'stroke-dasharray': '1 1'
          });
          x += w;
        }
      }

      /* ── QR code ──
         Encodes a URL that deep-links into Terra-Impact pre-filled with
         rifle, calibre, distance, session-name. Library is lazy-loaded;
         if it fails we print a text tag instead so nothing blocks. */
      var qrLibLoadPromise = null;
      function loadQrLibrary() {
        if (typeof window.qrcode === 'function') return Promise.resolve(true);
        if (qrLibLoadPromise) return qrLibLoadPromise;
        qrLibLoadPromise = new Promise(function(resolve) {
          var s = document.createElement('script');
          s.src = 'https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.min.js';
          s.async = true;
          s.onload = function() { resolve(typeof window.qrcode === 'function'); };
          s.onerror = function() { resolve(false); };
          document.head.appendChild(s);
        });
        return qrLibLoadPromise;
      }

      function buildQrPayload(config) {
        /* 2026-07-24 - HARD-CODED short-link base. Was window.location.origin
           with a 'https://terratarget.com' fallback. Three problems, and a QR is
           printed on paper so every one of them was permanent:
           1. Origin-derived means the QR encodes whatever host the customer
              happened to be browsing. Design a target on the myshopify preview
              domain (rj5wib-10.myshopify.com) and that host is baked into the
              print forever.
           2. The fallback domain 'terratarget.com' is not ours - we own
              terra-target.com.au. Any path that hit it produced a dead QR.
           3. terra-target.com.au/pages/terra-impact is a SHOPIFY PAGE URL. It
              breaks if the page handle changes, the store is restructured, or we
              ever leave Shopify - and it cannot be claimed as an Android App
              Link, because Shopify serves an empty [] at
              /.well-known/assetlinks.json on that host.
           go.terra-target.com.au is a Cloudflare Worker we control: it 302s to
           the Impact page today (query string preserved) and can be re-pointed
           anywhere later WITHOUT a reprint, which is the whole point of putting
           a short link on a physical product. It is also the host Terra-Confirm
           claims and verifies, so a camera scan opens the app directly.
           Shorter payload is a bonus: a lower-density QR survives being shot up,
           rained on and scanned at an angle far better. */
        var QR_BASE = 'https://go.terra-target.com.au/t';
        var params = [];
        if (config.sessionName) params.push('s=' + encodeURIComponent(config.sessionName));
        if (config.rifle)       params.push('r=' + encodeURIComponent(config.rifle));
        if (config.calibre)     params.push('c=' + encodeURIComponent(config.calibre));
        /* v55: encode distance as numeric metres (always metric on the
           wire). Was config.distance (e.g. "100yd"); Impact V66 still
           parses unit-tagged values for older targets. */
        if (config.distanceMetres && config.distanceMetres > 0) {
          params.push('d=' + encodeURIComponent(String(config.distanceMetres)));
        }
        /* (a) Marker type embedded so Terra-Impact can pre-select the
           correct preset from the QR scan. */
        if (config.markerLabel) params.push('m=' + encodeURIComponent(config.markerLabel));
        /* g=1 => report group size only, no scope correction. Omitted for the
           default 'zero' purpose so existing payloads are byte-identical and
           older prints keep behaving exactly as before. */
        if (config.purpose === 'group') params.push('g=1');
        return QR_BASE + '?' + params.join('&');
      }

      function addQrPlaceholder(svg, x, y, size, label) {
        /* Simple dashed square + label — used while the QR lib loads or if it fails */
        addRect(svg, x, y, size, size, {
          fill: 'none',
          stroke: '#8a968a',
          'stroke-width': 0.4,
          'stroke-dasharray': '1 1'
        });
        appendText(svg, {
          x: x + size / 2,
          y: y + size / 2 + 1.2,
          'font-size': 2.8,
          fill: '#5f695f',
          'text-anchor': 'middle'
        }, label || 'QR');
      }

      function drawQrCode(svg, dims, config) {
        var qrSize = QR_SIZE_MM;
        /* Page markers own the top-right corner (marker + white pad out to
           41mm from each edge), so the QR moves inboard of the pad at the same
           height - still inside the top-right crop Terra-Confirm scans for the
           QR, even on A4/Letter portrait. */
        var qrX = config.pageMarker
          ? dims.width - PAGE_QR_RIGHT_GAP_MM - qrSize
          : dims.width - 12 - qrSize;
        var qrY = 7;

        var payload = buildQrPayload(config);

        /* If the library is already loaded, draw immediately */
        if (typeof window.qrcode === 'function') {
          drawQrInto(svg, qrX, qrY, qrSize, payload);
          return;
        }

        /* Otherwise place a placeholder and trigger library load.
           Once loaded, re-render (cheap — render() is idempotent). */
        addQrPlaceholder(svg, qrX, qrY, qrSize, 'loading…');
        loadQrLibrary().then(function(loaded) {
          if (loaded) {
            /* Trigger a re-render so the QR shows up */
            try { render(); } catch (e) {}
          }
        });
      }

      function drawQrInto(svg, x, y, size, payload) {
        try {
          var qr = window.qrcode(0, 'M');
          qr.addData(payload);
          qr.make();
          var moduleCount = qr.getModuleCount();
          var cell = size / moduleCount;

          var g = createSvgNode('g', { 'class': 'terra-qr' });

          /* White background for quiet zone (slightly larger than the QR) */
          addRect(g, x - cell, y - cell, size + cell * 2, size + cell * 2, {
            fill: '#ffffff', stroke: 'none'
          });

          for (var r = 0; r < moduleCount; r += 1) {
            for (var c = 0; c < moduleCount; c += 1) {
              if (qr.isDark(r, c)) {
                addRect(g, x + c * cell, y + r * cell, cell, cell, {
                  fill: '#000000',
                  stroke: 'none',
                  'shape-rendering': 'crispEdges'
                });
              }
            }
          }

          svg.appendChild(g);
        } catch (err) {
          addQrPlaceholder(svg, x, y, size, 'QR error');
        }
      }

      /* ── Header / footer on printed target ── */
      function addHeader(svg, dims, fields) {
        var header = createSvgNode('g');
        /* Attached up front (it used to be appended last) so fitHeaderText()
           can measure real glyph widths. Nothing else is appended to svg in
           this function, so the document order is unchanged. */
        svg.appendChild(header);
        var x = fields.pageMarker ? PAGE_MARKER_CLEAR_MM : 12;
        /* v54: Reserve 20 mm right-side space for the QR code on
           every variant (was conditional on non-custom). The QR now
           draws on Custom targets too, so the header text needs the
           same right-margin reserve to avoid colliding with it. */
        var qrReserve = 20;
        /* With page markers the corners belong to the markers and the QR steps
           inboard of the top-right pad, so right-anchored lines end left of it. */
        var rightEdge = fields.pageMarker
          ? dims.width - PAGE_QR_RIGHT_GAP_MM - QR_SIZE_MM - 2
          : dims.width - 12 - qrReserve;
        /* Right edge of the logo (48mm box) or TERRA-TARGET wordmark, + 3mm air:
           lines that share its row must end right of it. */
        var brandRight = x + (fields.logoUrl ? 48 : 60) + 3;
        /* Landscape runs a compact header so the grid can fill a 210mm page;
           the tagline is dropped there for room. Divider is metaY+4 and the
           renderer's headerBottom is metaY+8 - keep in step: 38 / 28. */
        var compact = fields.orientation === 'landscape';
        var metaY   = compact ? 20 : 30;
        var logoY   = compact ? 3  : 4;
        var logoH   = compact ? 14 : 18;
        var y       = compact ? 12 : 14;  /* wordmark baseline when no logo */

        /* The meta row has to clear the LOGO, not merely sit at metaY. On the
           compact landscape header the logo occupies y 3..17 while metaY is
           20, and a 5mm font puts the text top at ~16.4 — it overprinted the
           logo. Push the baseline down only as far as needed (cap height
           ~0.72em, plus 1mm of air). Portrait already clears (logo bottom 22
           vs metaY 30) so Math.max leaves it untouched.
           metaY itself must NOT move: it anchors the divider (metaY+4) and the
           renderer's headerBottom (metaY+8), so shifting it would move the
           whole page layout and the aim centring with it. */
        var metaTextY = fields.logoUrl
          ? Math.max(metaY, logoY + logoH + 1 + 5 * 0.72)
          : metaY;

        if (fields.logoUrl) {
          header.appendChild(createSvgNode('image', {
            href: fields.logoUrl,
            x: x,
            y: logoY,
            width: 48,
            height: logoH,
            preserveAspectRatio: 'xMinYMid meet'
          }));
        } else {
          appendText(header, {
            x: x,
            y: y,
            'font-size': 8,
            'font-weight': '800',
            fill: '#172019'
          }, 'TERRA-TARGET');
        }

        /* Tagline is portrait-only: on the compact landscape header its row
           is where the session/notes line now sits. */
        if (!compact) {
          appendText(header, {
            x: rightEdge,
            y: 12,
            'font-size': 4.6,
            'font-weight': '700',
            fill: '#5f695f',
            'text-anchor': 'end'
          }, fields.brandLine || 'Check anywhere. Hunt everywhere.');
          if (fields.pageMarker) fitHeaderText(header.lastChild, rightEdge - brandRight, 3.2, { drop: true });
        }

        var headerBits = [];
        if (fields.rifle)    headerBits.push(fields.rifle);
        if (fields.calibre)  headerBits.push(fields.calibre);
        if (fields.distance) headerBits.push(fields.distance);
        if (fields.markerLabel) headerBits.push('MARKERS: ' + fields.markerLabel);
        /* (h) Grid spacing info on target */
        if (fields.gridSpacingLabel) headerBits.push('GRID: ' + fields.gridSpacingLabel);

        appendText(header, {
          x: x,
          y: metaTextY,
          'font-size': 5,
          'font-weight': '700',
          fill: '#1b241d'
        }, headerBits.length ? headerBits.join('  •  ') : 'Field printable target');
        if (fields.pageMarker) {
          fitHeaderText(header.lastChild, (compact ? rightEdge : dims.width - PAGE_MARKER_CLEAR_MM) - x, 4, {
            parts: headerBits,
            sep: '  •  ',
            cuttable: (fields.rifle ? 1 : 0) + (fields.calibre ? 1 : 0)
          });
        }

        /* Right-side detail line: session name + notes.
           v48: moved off metaY (which hosts left-anchored
           rifle/calibre/grid bits) onto its own dedicated row
           above. Long session names previously grew leftward and
           collided with the rifle/calibre text in the middle of
           the header. The new row sits between the brand line
           (y=12) and the metadata row (y=metaY=30); both right-
           anchored elements stack cleanly at the same x. */
        var rightLine = [];
        if (fields.sessionName) rightLine.push(fields.sessionName);
        if (fields.notes) rightLine.push(fields.notes);
        if (rightLine.length) {
          appendText(header, {
            x: rightEdge,
            y: metaY - 8,
            'font-size': 4.2,
            fill: '#5f695f',
            'text-anchor': 'end'
          }, rightLine.join('  ·  '));
          if (fields.pageMarker) {
            fitHeaderText(header.lastChild, rightEdge - brandRight, 3.4, {
              parts: rightLine,
              sep: '  ·  ',
              cuttable: rightLine.length
            });
          }
        }

        addLine(header, x, metaY + 4, dims.width - (fields.pageMarker ? PAGE_MARKER_CLEAR_MM : 12), metaY + 4, { stroke: '#d5ddd2', 'stroke-width': 0.5 });
      }

      /* Page-marker header lines live between the corner markers' 32mm detector
         squares, so each is fitted to its slot: shrink toward minFontSize; then
         cut the user's own text (opts.parts[0..cuttable), all long parts to one
         length) so fixed labels such as MARKERS: TT13 survive; then drop the
         user's text; then cut what is left; else remove the line. opts.drop
         removes instead of cutting.
         getComputedTextLength() is exact once the preview is laid out; while it
         is hidden (mobile width) it returns 0 and a 0.66em-per-character
         estimate stands in - wide enough for the upper-case meta row. */
      function fitHeaderText(node, maxWidth, minFontSize, opts) {
        if (!node || !node.parentNode) return;
        opts = opts || {};
        var usingParts = !!(opts.parts && opts.parts.length);
        var parts = usingParts ? opts.parts : [node.textContent || ''];
        var sep = usingParts ? (opts.sep || '') : '';
        var cuttable = usingParts ? Math.min(opts.cuttable || 0, parts.length) : 0;
        function widthNow() {
          var w = 0;
          try { w = node.getComputedTextLength(); } catch (e) { w = 0; }
          return w > 0 ? w : node.textContent.length * parseFloat(node.getAttribute('font-size')) * 0.66;
        }
        function cut(text, keep) {
          return text.length > keep ? text.slice(0, keep).replace(/\s+$/, '') + '\u2026' : text;
        }
        /* Largest keep in [lo, hi] whose text fits; width never shrinks as keep grows. */
        function largestFit(lo, hi, build) {
          var best = -1;
          while (lo <= hi) {
            var mid = (lo + hi) >> 1;
            node.textContent = build(mid);
            if (widthNow() <= maxWidth) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
          }
          if (best >= 0) node.textContent = build(best);
          return best;
        }
        var fontSize = parseFloat(node.getAttribute('font-size')) || 4;
        var width = widthNow();
        if (width <= maxWidth) return;
        var shrunk = Math.floor(fontSize * (maxWidth / width) * 10) / 10;
        if (minFontSize && shrunk >= minFontSize) {
          node.setAttribute('font-size', shrunk);
          return;
        }
        if (!opts.drop) {
          if (minFontSize) node.setAttribute('font-size', minFontSize);
          var longest = 0;
          for (var i = 0; i < cuttable; i += 1) longest = Math.max(longest, parts[i].length);
          if (largestFit(6, longest - 1, function (keep) {
            return parts.map(function (part, j) { return j < cuttable ? cut(part, keep) : part; }).join(sep);
          }) >= 0) return;
          /* Still too long: the fixed labels outrank a stub of the user's text. */
          var fixed = cuttable ? parts.slice(cuttable).join(sep) : '';
          if (fixed) {
            node.textContent = fixed;
            if (widthNow() <= maxWidth) return;
          }
          var full = fixed || parts.join(sep);
          if (largestFit(6, full.length - 1, function (keep) { return cut(full, keep); }) >= 0) return;
        }
        node.parentNode.removeChild(node);
      }

      function addFooterStrip(svg, dims, footerY, footerHeight, inset) {
        var edge = inset || 12;
        addRect(svg, edge, footerY, dims.width - edge * 2, footerHeight, {
          fill: '#f6f8f5',
          stroke: '#d6ddd3',
          'stroke-width': 0.45
        });

        /* (e) Simplified strip: Date, Ammo/Load, Notes — only shown on Custom */
        var labels = ['Date', 'Ammo / Load', 'Notes'];
        var widths = [0.18, 0.32, 0.50];
        var currentX = edge;
        for (var i = 0; i < labels.length; i += 1) {
          var cellWidth = (dims.width - edge * 2) * widths[i];
          if (i > 0) {
            addLine(svg, currentX, footerY, currentX, footerY + footerHeight, {
              stroke: '#d6ddd3',
              'stroke-width': 0.35
            });
          }
          appendText(svg, {
            x: currentX + 3,
            y: footerY + 5,
            'font-size': 3.8,
            'font-weight': '700',
            fill: '#5f695f'
          }, labels[i]);
          addLine(svg, currentX + 3, footerY + footerHeight - 4.5, currentX + cellWidth - 3, footerY + footerHeight - 4.5, {
            stroke: '#c8d0c6',
            'stroke-width': 0.25,
            'stroke-dasharray': '1.2 1.2'
          });
          currentX += cellWidth;
        }
      }

      /* ── Print-check scale ──
         Renders a ruler at the bottom of the page (in the 8 mm band
         above footerY) so the user can verify their printer didn't
         apply fit-to-page scaling. The SVG viewBox is 1:1 with paper mm
         (width="210mm" viewBox="0 0 210 297"), so a 100 mm-wide line in
         SVG renders as exactly 100 mm on paper at 100% print scale.

         v40: unit-aware. In metric mode the ruler is 100 mm long with
         5 mm minor ticks; in imperial mode it's 4 in (= 101.6 mm)
         long with 1/4 in minor ticks. Both fit the same vertical
         band — physical lengths are within 2% of each other so layout
         doesn't change. The caption tells the user exactly what to
         measure ("RULER SHOULD READ 100 mm" or "RULER SHOULD READ 4
         in") so there's no ambiguity at print time. */
      function addPrintCheckScale(parent, contentArea, footerY, unitSystem) {
        var isImperial = (unitSystem === 'imperial');

        /* Build tick + label specs as data, then render uniformly.
           Tick height tiers are consistent across units:
             1.8 mm  endpoints (0 / max)
             1.5 mm  midpoint (50 mm or 2 in)
             1.1 mm  next-down (10 mm or 1 in)
             0.6 mm  smallest (5 mm or 1/4 in) */
        var scaleMm, captionText, ticks = [], labels = [];

        if (isImperial) {
          var QUARTER = 25.4 / 4;        /* 6.35 mm = 1/4 in */
          scaleMm = 4 * 25.4;            /* 101.6 mm */
          captionText = 'PRINT CHECK \u2014 RULER SHOULD READ 4 in';
          for (var qi = 0; qi <= 16; qi += 1) {
            var pos = qi * QUARTER;
            var qh;
            if (qi === 0 || qi === 16) qh = 1.8;     /* whole-inch endpoints */
            else if (qi === 8)         qh = 1.5;     /* 2 in midpoint */
            else if (qi % 4 === 0)     qh = 1.1;     /* 1 / 3 in */
            else if (qi % 2 === 0)     qh = 0.85;    /* 1/2 in marks */
            else                       qh = 0.6;     /* 1/4 in marks */
            ticks.push({ pos: pos, height: qh });
          }
          labels = [
            { pos: 0,        text: '0' },
            { pos: 25.4,     text: '1' },
            { pos: 50.8,     text: '2' },
            { pos: 76.2,     text: '3' },
            { pos: 101.6,    text: '4' }
          ];
        } else {
          scaleMm = 100;
          captionText = 'PRINT CHECK \u2014 RULER SHOULD READ 100 mm';
          for (var mi = 0; mi <= 100; mi += 5) {
            var mh;
            if (mi === 0 || mi === 100) mh = 1.8;
            else if (mi === 50)         mh = 1.5;
            else if (mi % 10 === 0)     mh = 1.1;
            else                        mh = 0.6;
            ticks.push({ pos: mi, height: mh });
          }
          labels = [
            { pos: 0,   text: '0' },
            { pos: 50,  text: '50' },
            { pos: 100, text: '100' }
          ];
        }

        var cx = contentArea.x + contentArea.width / 2;
        var halfW = scaleMm / 2;
        var leftX = cx - halfW;

        /* Layout (bottom-up within the 8 mm band):
              footerY -1.0   baseline of horizontal ruler line
              footerY -2.8   tops of major ticks (1.8 mm tall)
              footerY -3.5   text baseline of tick labels
              footerY -5.7   text baseline of caption
              footerY -7.0   cap height of caption (1 mm clear of target) */
        var baselineY = footerY - 1.0;
        var stroke = '#7a857a';
        var textFill = '#5f6c5f';

        var g = createSvgNode('g', { 'class': 'terra-print-check' });

        /* Caption above the scale */
        appendText(g, {
          x: cx,
          y: footerY - 5.7,
          'text-anchor': 'middle',
          'font-family': 'Barlow Condensed, Barlow, sans-serif',
          'font-size': 2.0,
          'font-weight': '600',
          'letter-spacing': 0.3,
          fill: textFill
        }, captionText);

        /* Horizontal baseline */
        addLine(g, leftX, baselineY, leftX + scaleMm, baselineY, {
          stroke: stroke,
          'stroke-width': 0.5,
          'vector-effect': 'non-scaling-stroke'
        });

        /* Ticks pointing UP from the baseline so label text can sit
           above without competing with the footer below. */
        for (var ti = 0; ti < ticks.length; ti += 1) {
          var tick = ticks[ti];
          var tx = leftX + tick.pos;
          addLine(g, tx, baselineY, tx, baselineY - tick.height, {
            stroke: stroke,
            'stroke-width': 0.5,
            'vector-effect': 'non-scaling-stroke'
          });
        }

        /* Tick labels — small, above the major ticks. */
        for (var li = 0; li < labels.length; li += 1) {
          appendText(g, {
            x: leftX + labels[li].pos,
            y: footerY - 3.5,
            'text-anchor': 'middle',
            'font-family': 'Barlow Condensed, Barlow, sans-serif',
            'font-size': 1.9,
            'font-weight': '600',
            fill: textFill
          }, labels[li].text);
        }

        parent.appendChild(g);
      }

      /* Title baseline, ABOVE the grid area.
         The top row of grid labels is drawn at area.y - 1.2 (see
         addGridLabels), so the old -2 / -3.5 offsets put a 4.6mm title glyph
         straight through them - reported 2026-08-07 with "USER CUSTOM TARGET"
         sitting on the 1.0 labels.
         Clearance is only needed when that label row actually exists, so this
         stays tight when labels are off (or there is no grid) rather than
         leaving every such sheet with a gap it does not need. */
      /* baseGap is each layout's ORIGINAL offset, kept per-layout rather than
         flattened to one number: the zero sheet has always sat 1.5mm tighter
         than the single target (2 vs 3.5) because its header rule is closer to
         the grid. A flat 8mm cleared the labels but pushed ZERO POINT up into
         that rule, so the clearance is added TO each layout's own offset.
         4.5mm is what the label row needs: labels sit on baseline area.y - 1.2
         with an ascender reaching ~area.y - 3.6, and a 4.6mm title needs its
         descender (~0.9) plus a gap below that. */
      var TITLE_LABEL_CLEARANCE_MM = 4.5;
      function titleBaselineY(area, config, baseGap) {
        var base = (typeof baseGap === 'number') ? baseGap : 3.5;
        var hasTopLabels = !!(config && config.showGridLabels && config.gridSize > 0);
        return area.y - (hasTopLabels ? base + TITLE_LABEL_CLEARANCE_MM : base);
      }

      function addTitle(svg, x, y, text) {
        appendText(svg, {
          x: x,
          y: y,
          'font-size': 4.6,
          'font-weight': '700',
          fill: '#4f5c50',
          'text-anchor': 'middle'
        }, text);
      }

      /* ── Target layout drawing ── */
      function drawSingleTarget(svg, area, config, variant, title) {
        /* Aim at the EXACT area centre. Pre-v36, this was passed through
           snapToGridCrossing which moved the aim to the nearest grid
           multiple — on A4 with 20mm spacing the page centre x=105 snaps
           to x=100, putting the entire target 5mm left of page centre.
           With grid off the snap was bypassed and the aim landed dead
           centre, which is why "grid off looks fine, grid on is shifted"
           was the user-visible regression. v36's addGrid anchors lines
           at the origin, so the grid adapts to wherever the aim sits —
           no snap required, and the heavy "every 5th" line still passes
           through the aim because origin-anchored math handles that
           automatically. Same change applied to drawZeroSheet below and
           already in place for drawMultiGrid (v36). */
        var aimPoint = {
          x: area.x + area.width / 2,
          y: area.y + area.height / 2
        };
        /* Page markers put the aim at PAGE centre - Terra-Confirm measures
           from the centre of the marker rectangle. */
        aimPoint = pageAimPoint(config, aimPoint);
        var aimMarker = resolveAimAndMarkerOnPage(area, aimPoint, config);
        var markerSpacing = aimMarker.markerSpacing;
        var maxAim = aimMarker.maxAim;
        var effectiveAimSize = aimMarker.effectiveAim;
        addGrid(svg, area, config.gridSize, config.gridStrength, aimPoint, config.gridMajorEvery);
        if (config.showGridLabels && config.distanceMetres > 0) {
          addGridLabels(svg, area, aimPoint, config.gridSize, config.distanceMetres, config.gridLabelUnit, config.gridMajorEvery);
        }
        /* MOA rings go under everything else (rings → ethical → holdover →
           aim → markers). drawSingleTarget previously skipped this call,
           which meant Custom preset (targetStyle 'diamond' → here) and
           Cold Bore presets (which dispatch to drawSingleTarget twice
           via drawColdBore) silently dropped MOA rings even when the
           toggle was set to On / Auto. */
        addMoaRings(svg, area, aimPoint, config);
        /* Ethical-range rings go under the aim point */
        addEthicalRangeRings(svg, area, aimPoint, config);
        /* Holdover ladder (reference lines below aim) */
        addHoldoverLadder(svg, area, aimPoint, config);
        addAimPoint(svg, aimPoint.x, aimPoint.y, effectiveAimSize, config.aimStyle, variant);
        /* Shot counter rings overlay the aim point area */

        if (markerSpacing && !config.pageMarker) addReferenceMarkersAround(svg, area, aimPoint, markerSpacing);
        if (title) addTitle(svg, aimPoint.x, titleBaselineY(area, config), title);
        return { maxAim: maxAim, markerSpacing: markerSpacing, effectiveAim: effectiveAimSize };
      }

      function drawColdBore(svg, contentArea, footerY, config) {
        /* Horizontal gap between the two side-by-side targets is
           independent from the bottom reserve that holds the
           print-check scale. Pre-v39 these were fused as `gap`. */
        var hGap = 10;
        var bottomReserve = 8;
        var usableHeight = footerY - contentArea.y - bottomReserve;
        var leftArea = {
          x: contentArea.x,
          y: contentArea.y + 8,
          width: (contentArea.width - hGap) / 2,
          height: usableHeight - 8
        };
        var rightArea = {
          x: contentArea.x + leftArea.width + hGap,
          y: contentArea.y + 8,
          width: (contentArea.width - hGap) / 2,
          height: usableHeight - 8
        };
        var leftResult = drawSingleTarget(svg, leftArea, config, 'dot', 'SHOT 1');
        var rightResult = drawSingleTarget(svg, rightArea, config, 'dot', 'FOLLOW-UP GROUP');
        return {
          maxAim: Math.min(leftResult.maxAim, rightResult.maxAim),
          markerSpacing: leftResult.markerSpacing || rightResult.markerSpacing,
          effectiveAim: Math.min(leftResult.effectiveAim, rightResult.effectiveAim)
        };
      }

      function drawZeroSheet(svg, contentArea, footerY, config) {
        var area = {
          x: contentArea.x,
          y: contentArea.y + 6,
          width: contentArea.width,
          /* Bottom reserve = 8 mm: print-check scale band (v39). */
          height: footerY - contentArea.y - 8
        };
        /* Same fix as drawSingleTarget — aim at the exact intended
           position (slightly above middle for zero-sheet ergonomics)
           rather than snapping to a grid multiple. The grid anchors
           itself here via addGrid(... aimPoint). */
        var aimPoint = {
          x: area.x + area.width / 2,
          y: area.y + area.height * 0.46
        };
        /* Page markers put the aim at PAGE centre - Terra-Confirm measures
           from the centre of the marker rectangle. */
        aimPoint = pageAimPoint(config, aimPoint);
        var aimMarker = resolveAimAndMarkerOnPage(area, aimPoint, config);
        var markerSpacing = aimMarker.markerSpacing;
        var maxAim = aimMarker.maxAim;
        var effectiveAimSize = aimMarker.effectiveAim;
        addGrid(svg, area, config.gridSize, config.gridStrength, aimPoint, config.gridMajorEvery);
        if (config.showGridLabels && config.distanceMetres > 0) {
          addGridLabels(svg, area, aimPoint, config.gridSize, config.distanceMetres, config.gridLabelUnit, config.gridMajorEvery);
        }
        addMoaRings(svg, area, aimPoint, config);
        addEthicalRangeRings(svg, area, aimPoint, config);
        addHoldoverLadder(svg, area, aimPoint, config);
        addAimPoint(svg, aimPoint.x, aimPoint.y, effectiveAimSize, config.aimStyle, 'dot');

        if (markerSpacing && !config.pageMarker) addReferenceMarkersAround(svg, area, aimPoint, markerSpacing);
        addTitle(svg, aimPoint.x, titleBaselineY(area, config, 2), config.pageTitleOverride || 'ZERO POINT');
        return { maxAim: maxAim, markerSpacing: markerSpacing, effectiveAim: effectiveAimSize };
      }


      /* ── Multi-aim grid ──
         User-defined N×M grid of small targets, each with its own aim
         point, grid, ethical/holdover/MOA overlays, and (when room
         permits) reference markers for per-cell Terra-Impact analysis.
         Cells are numbered in row-major order (1..N) for engagement
         drills. Aim point size auto-shrinks per cell. */
      function parseMultiGridLayout(layout) {
        var match = String(layout || '2x2').toLowerCase().match(/^(\d+)x(\d+)$/);
        if (!match) return { rows: 2, cols: 2 };
        var rows = Math.max(1, Math.min(5, parseInt(match[1], 10) || 2));
        var cols = Math.max(1, Math.min(5, parseInt(match[2], 10) || 2));
        return { rows: rows, cols: cols };
      }

      function drawMultiGrid(svg, contentArea, footerY, config) {
        var gridTop = contentArea.y + 8;
        /* Bottom reserve = 8 mm: print-check scale band (v39).
           Was 6 mm pre-v39 — bumped 2 mm for the scale; this trims
           ~0.67 mm per cell in a 3-row layout (imperceptible). */
        var gridBottom = footerY - 8;
        var gridHeight = gridBottom - gridTop;

        var layout = parseMultiGridLayout(config.multiGridLayout);
        var rows = layout.rows;
        var cols = layout.cols;
        var totalCells = rows * cols;

        /* Tighter gaps for denser grids so each cell stays usable */
        var hGap = (cols >= 3) ? 6 : 9;
        var vGap = (rows >= 3) ? 5 : 7;
        var cellWidth = (contentArea.width - hGap * (cols - 1)) / cols;
        var cellHeight = (gridHeight - vGap * (rows - 1)) / rows;

        var labelIndex = 1;
        var minMaxAim = Infinity;
        var anyMarkerSpacing = null;
        var minEffective = Infinity;

        for (var r = 0; r < rows; r += 1) {
          for (var c = 0; c < cols; c += 1) {
            if (labelIndex > totalCells) break;
            var cell = {
              x: contentArea.x + c * (cellWidth + hGap),
              y: gridTop + r * (cellHeight + vGap),
              width: cellWidth,
              height: cellHeight
            };
            /* Aim at the EXACT cell midpoint (no grid snap). The grid
               anchors itself at this point via addGrid(... aimPoint),
               so heavy lines automatically pass through the aim AND
               every cell ends up with an identical relative grid
               pattern regardless of fractional cell.y. The legacy snap
               (snapToGridCrossing) caused drift between cells because
               grid lines were absolute multiples of spacing while
               cell.y was fractional — see v36 fix notes. */
            var aimPoint = {
              x: cell.x + cell.width / 2,
              y: cell.y + cell.height / 2
            };
            var aimMarker = resolveAimAndMarker(cell, aimPoint, config);
            var markerSpacing = aimMarker.markerSpacing;
            var maxAim = aimMarker.maxAim;
            var effectiveAimSize = aimMarker.effectiveAim;

            addGrid(svg, cell, config.gridSize, config.gridStrength, aimPoint, config.gridMajorEvery);
            if (config.showGridLabels && config.distanceMetres > 0) {
              addGridLabels(svg, cell, aimPoint, config.gridSize, config.distanceMetres, config.gridLabelUnit, config.gridMajorEvery);
            }
            /* Ethical / MOA / holdover overlays sit underneath the aim mark.
               Skip MOA rings on dense layouts (3×3) where they crowd the cell. */
            addEthicalRangeRings(svg, cell, aimPoint, config);
            if (totalCells <= 6) {
              addMoaRings(svg, cell, aimPoint, config);
            }
            addHoldoverLadder(svg, cell, aimPoint, config);
            addAimPoint(svg, aimPoint.x, aimPoint.y, effectiveAimSize, config.aimStyle, 'dot');

            if (markerSpacing) addReferenceMarkersAround(svg, cell, aimPoint, markerSpacing);

            /* Numbered engagement-order label above each cell.
               Generously sized so the number reads fast at distance. */
            var labelY = cell.y - 1.5;
            var labelText = String(labelIndex);
            /* Small filled badge so the number stands out against the grid */
            addCircle(svg, aimPoint.x, labelY - 1.6, 2.6, {
              fill: '#1b241d',
              stroke: 'none'
            });
            appendText(svg, {
              x: aimPoint.x,
              y: labelY,
              'font-size': 4.2,
              'font-weight': '800',
              fill: '#ffffff',
              'text-anchor': 'middle'
            }, labelText);

            labelIndex += 1;
            if (maxAim < minMaxAim) minMaxAim = maxAim;
            if (!anyMarkerSpacing && markerSpacing) anyMarkerSpacing = markerSpacing;
            if (effectiveAimSize < minEffective) minEffective = effectiveAimSize;
          }
        }

        return {
          maxAim: minMaxAim === Infinity ? 150 : minMaxAim,
          markerSpacing: anyMarkerSpacing,
          effectiveAim: minEffective === Infinity ? 0 : minEffective
        };
      }


      /* ── Value helpers ── */
      function clampAimSize(value) {
        var number = parseFloat(value);
        if (isNaN(number)) number = 40;
        return Math.max(10, Math.min(400, number));
      }

      /* ── Aim size unit conversion ── (v40)
         The aim-size NUMBER INPUT shows the value in the active display
         unit (mm in metric, in in imperial). The slider stays in mm
         under the hood. All internal state (config.aimSize, preset
         storage, render/draw) is in mm — conversion only happens at
         the input/output boundary. */
      var MM_PER_INCH = 25.4;

      function aimDisplayToMm(displayValue, unit) {
        var v = parseFloat(displayValue);
        if (isNaN(v)) return NaN;
        return (unit === 'imperial') ? v * MM_PER_INCH : v;
      }

      function mmToAimDisplay(mm, unit) {
        if (unit === 'imperial') {
          /* 0.1 in resolution. 0.1 in = 2.54 mm — close enough for an
             aim circle on a hunting target. The number input accepts
             any precision the user types; this is just the rounded
             value we DISPLAY. */
          return Math.round((mm / MM_PER_INCH) * 10) / 10;
        }
        return Math.round(mm);
      }

      /* Read the canonical aim size in mm regardless of which unit the
         number input is currently in. Used by getConfig() and
         buildPresetFromUI() so internal state is always mm. */
      function getDisplayedAimSizeMm() {
        var raw = byId('terra-aim-size-value');
        if (!raw) return 40;
        var mm = aimDisplayToMm(raw.value, getActiveUnit());
        if (isNaN(mm)) mm = 40;
        return Math.max(10, Math.min(400, mm));
      }

      /* Write a mm value to the aim number input, converting to display
         unit. Doesn't fire input/change events. */
      function setAimSizeDisplay(mm, unit) {
        var input = byId('terra-aim-size-value');
        if (!input) return;
        var display = mmToAimDisplay(mm, unit || getActiveUnit());
        input.value = String(display);
      }

      /* Lower-case a free-text number and make it safe for parseFloat.
         The `.replace(',', '.')` here is the original European decimal
         comma handling, and on its own it fired on the FIRST comma
         wherever it sat: "1,000m" became "1.000m" and parsed as ONE
         metre. That was survivable while a grid was 20 mm no matter what
         the distance said — only the axis numbers, the MOA rings and the
         holdover ladder were wrong, and all three are re-measurable — but
         an MOA grid is computed FROM the distance. "1 MOA" at "1,000m"
         resolved to 0.29 mm, fell through GRID_MIN_SPACING_MM and deleted
         the grid from the preview and the print, while the readout
         blamed a range the user had typed correctly.

         A comma followed by exactly three digits is a thousands
         separator and is dropped; anything else is still a decimal
         point, so "1,25" keeps meaning 1.25. That does read "1,250" as
         1250 rather than 1.25 — but nobody sets a target at 1.25 m, and
         the spacing floor would refuse a grid there anyway. */
      function normaliseTypedNumber(value) {
        return String(value).trim().toLowerCase()
          .replace(/,(?=[0-9]{3}(?![0-9]))/g, '')
          .replace(',', '.');
      }

      function parseDistanceMetres(value, unitSystem) {
        if (!value) return NaN;
        var raw = normaliseTypedNumber(value);
        var match = raw.match(/([0-9]+(?:\.[0-9]+)?)/);
        if (!match) return NaN;
        var amount = parseFloat(match[1]);
        if (isNaN(amount) || amount <= 0) return NaN;

        if (raw.indexOf('yd') !== -1 || raw.indexOf('yard') !== -1) {
          return amount * 0.9144;
        }
        if (raw.indexOf('km') !== -1) {
          return amount * 1000;
        }
        if (raw.indexOf('m') !== -1) {
          return amount;
        }
        /* No unit tag at all — read it in the unit the user is working
           in. It used to be metres unconditionally, so an imperial user
           who cleared the field and typed "300" meaning yards got a grid
           built for 300 m: 1 MOA resolves to 87.27 mm there, where 1 MOA
           at 300 yd is 79.79 mm. A 9.4% error, and since the change it is
           printed as GEOMETRY rather than as a label — before, the sheet
           still carried a true 10 mm grid the shooter could measure
           against and correct. applyUrlParams already tags a bare
           distance with the active unit for this exact reason (see its
           v55 note); this is the same rule applied to what gets typed.
           Callers that pass no unit keep the old metres reading. */
        return (unitSystem === 'imperial') ? amount * 0.9144 : amount;
      }

      function getActiveAimStyle() {
        var active = root().querySelector('#terra-aim-style-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-aim-style') : 'dot-only';
      }

      function getActiveGridStrength() {
        var active = root().querySelector('#terra-grid-strength-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-grid-strength') : 'field';
      }

      function getActiveMarkerMode() {
        var active = root().querySelector('#terra-marker-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-marker') : 'auto';
      }

      function getActivePurpose() {
        var active = root().querySelector('#terra-purpose-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-purpose') : 'zero';
      }

      function getActiveHoldover() {
        var active = root().querySelector('#terra-holdover-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-holdover') : 'off';
      }

      function getActiveUnit() {
        var active = root().querySelector('#terra-unit-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-unit') : 'metric';
      }

      function getActiveMultiGridLayout() {
        var active = root().querySelector('#terra-multi-grid-layout-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-multi-grid-layout') : '2x2';
      }

      function getActivePreset() {
        var sel = byId('terra-preset-select');
        return sel ? sel.value : 'cold_bore_ss';
      }

      /* ── Config builder ── */
      function getConfig() {
        var paperSize = byId('terra-paper-size').value;
        var orientation = byId('terra-orientation').value;
        var targetStyle = byId('terra-target-style').value;
        /* Raw select value only — resolving it to millimetres needs the
           distance, which isn't parsed until further down. Leaving the
           resolution here would read an undefined local and produce a
           NaN spacing, which addGrid swallows silently (its `!spacing`
           guard treats NaN as "no grid"). The DOM read stays at its
           original position so control-read ordering is unchanged. */
        var gridSelection = byId('terra-grid-size').value;
        var gridStrength = getActiveGridStrength();
        var aimStyle = getActiveAimStyle();
        /* The aim-size value lives on the number input — that's the
           canonical "user intent" because it accepts a wider range
           (10–400 mm) than the slider's step-1 visual scrubber (20–150).
           render() mirrors the value back onto both controls each frame
           so they stay in sync regardless of which the user touched. */
        /* Aim size in canonical mm regardless of the user's current
           display unit (the input shows inches when imperial). v40. */
        var aimSize = getDisplayedAimSizeMm();
        var showNotes = !!byId('terra-show-notes').checked;
        var distanceText = byId('terra-distance').value.trim();
        var dims = paperDimensions(paperSize, orientation);
        /* Sticker-guide aims (used by the Splatter Target preset) represent
           a physical sticker that is exactly aimSize mm regardless of paper.
           paperScaleFactor would make an 80 mm box render as 76 mm on Letter
           or 92.8 mm on A3 — both are wrong; the printed box must match
           the real-world sticker. All other aim styles are visual / abstract
           and benefit from gentle paper-scaling. */
        var scaledAimSize = (aimStyle === 'sticker-guide')
          ? aimSize
          : clampAimSize(aimSize * paperScaleFactor(paperSize));
        var showGridLabels = !!byId('terra-show-grid-labels').checked;
        var gridLabelUnit = byId('terra-grid-label-unit').value;
        /* The unit matters to the parse, not just to the display: an
           untagged distance means yards in imperial. Same read as the
           gridSpacingLabel and unitSystem fields below. */
        var distanceMetres = parseDistanceMetres(distanceText, getActiveUnit());
        /* Normalise BEFORE resolving so resolveGridSpacing sees the same
           "0 means unknown" sentinel the rest of the config exposes. */
        var safeDistanceMetres = isNaN(distanceMetres) ? 0 : distanceMetres;
        var grid = resolveGridSpacing(gridSelection, safeDistanceMetres);
        var markerMode = getActiveMarkerMode();
        var holdover = getActiveHoldover();
        var ethicalGame = byId('terra-ethical-game').value;
        var conditionsRow = !!byId('terra-conditions-row').checked;
        var sessionName = byId('terra-session-name').value.trim();
        var activePreset = getActivePreset();
        var multiGridLayout = getActiveMultiGridLayout();

        /* Reference markers respect the user's choice in every mode now,
           including Custom for any target style. The marker panel is
           always visible (see CSS) and resolveMarkerSpacing() returns
           null per-cell / per-area when the chosen TT preset doesn't
           fit, so the only effect of an unsuitable choice is that no
           markers render — never a crash, never a partial render. */
        var effectiveMarkerMode = markerMode;

        return {
          paperSize: paperSize,
          orientation: orientation,
          targetStyle: targetStyle,
          /* Still millimetres, still 0 = draw nothing — every consumer
             downstream is unchanged. The MOA fields ride alongside for
             the label, the readout and the saved preset. */
          gridSize: grid.mm,
          gridMode: grid.mode,
          gridMajorEvery: grid.majorEvery,
          gridState: grid.state,
          gridModeLabel: grid.label,
          gridRefusedMm: grid.refusedMm,
          gridStrength: gridStrength,
          aimStyle: aimStyle,
          aimSize: aimSize,
          scaledAimSize: scaledAimSize,
          showNotes: showNotes,
          showGridLabels: showGridLabels,
          gridLabelUnit: gridLabelUnit,
          distanceMetres: safeDistanceMetres,
          rifle: byId('terra-rifle').value.trim(),
          calibre: byId('terra-calibre').value.trim(),
          distance: distanceText,
          notes: byId('terra-notes').value.trim(),
          markerMode: effectiveMarkerMode,
          holdover: holdover,
          ethicalGame: ethicalGame,
          conditionsRow: conditionsRow,
          sessionName: sessionName,
          multiGridLayout: multiGridLayout,
          activePreset: activePreset,
          pageTitleOverride: runtimeState.pageTitleOverride || null,
          moaRings: resolveMoaRings(),
          multiPage: runtimeState.multiPage || 1,
          gridSpacingLabel: formatGridSpacingLabel(grid, getActiveUnit()),
          unitSystem: getActiveUnit(),
          logoUrl: TB_CFG.logoUrl,
          brandLine: TB_CFG.brandLine,
          dims: dims
        };
      }

      /* MOA rings value — 'on' fills the grid, 'off' draws nothing.
         The preset's moaRings field still drives initial button state
         (see applyPresetData) but at runtime there's no preset-driven
         middle ground — it's a binary user toggle. */
      function resolveMoaRings() {
        return getActiveMoaRings() === 'on' ? 999 : 0;
      }

      function getActiveMoaRings() {
        var active = root().querySelector('#terra-moa-rings-grid-' + sectionId + ' .terra-choice-button.active');
        return active ? active.getAttribute('data-moa-rings') : 'off';
      }

      /* (h) Grid spacing label printed on target header.
         Takes the resolved grid object (not a bare mm number) because an
         MOA grid cannot be described honestly by its millimetres alone:

           • The old metric branch was raw float concatenation, so a
             1/4 MOA grid at 100 m would have printed
             "GRID: 7.272200000000001 mm".
           • The imperial branch identifies a spacing by MILLIMETRES with
             a ±0.254 mm window, so a 1/4 MOA grid at 87.3 m computes to
             6.3496 mm and would have printed "GRID: 1/4 in" — the wrong
             unit entirely, confidently.

         The range is NOT repeated inside the grid bit. An angular spacing
         is only true at the distance it was built for and paper outlives
         the session that made it, so the first cut printed
         "1/4 MOA @ 100m (7.3 mm)" — but addHeader already pushes
         fields.distance onto the same row two bits earlier, from the same
         distanceText, and a resolved MOA grid cannot exist without one.
         The provenance was on the sheet twice and the row could not
         afford it: that row is a single non-wrapping <text> at x=12,
         font-size 5, weight 700, with no truncation, and the outermost
         <svg> clips at the viewBox edge in both preview and print host.
         Measured with Arial Bold advance metrics, "Tikka T3x Lite •
         .308 Win • 100m • MARKERS: TT3 • GRID: 1/4 MOA @ 100m (7.3 mm)"
         ends at x=222.6 on a 210 mm page — the 13 mm cut off is exactly
         the "(7.3 mm)" this label exists to print. Without the repeat it
         ends at 202.1. The refused states used to append "at 25m" the
         same way and overflowed the same way.

         The row is still unbounded: no field is truncated, so a long
         enough rifle name clips it with or without a grid bit. That is
         older than MOA spacings and wants its own decision. */
      function formatGridSpacingLabel(grid, unitSystem) {
        if (!grid) return 'No grid';
        if (grid.state === 'no-distance') return grid.label + ' — no distance set';
        if (grid.state === 'too-fine')    return grid.label + ' — too fine';
        if (!grid.mm || grid.mm <= 0) return 'No grid';
        if (grid.state === 'ok') {
          if (unitSystem === 'imperial') {
            return grid.label + ' (' + (grid.mm / 25.4).toFixed(2) + ' in)';
          }
          return grid.label + ' (' + grid.mm.toFixed(1) + ' mm)';
        }
        if (unitSystem === 'imperial') {
          /* Common imperial grid values */
          var inches = grid.mm / 25.4;
          if (Math.abs(inches - 0.25) < 0.01) return '1/4 in';
          if (Math.abs(inches - 0.5) < 0.01)  return '1/2 in';
          if (Math.abs(inches - 1) < 0.01)    return '1 in';
          return inches.toFixed(2) + ' in';
        }
        return grid.mm + ' mm';
      }

      /* ── Live MOA helper text ── */
      function updateMoaReadout(config) {
        var readout = byId('terra-moa-readout');
        var text = byId('terra-moa-readout-text');
        if (!readout || !text) return;

        var gridSize = config.gridSize;
        var distance = config.distanceMetres;
        var unit = config.gridLabelUnit === 'mil' ? 'MIL' : 'MOA';
        var distLabel = config.distance || '—';

        /* Branch order is load-bearing. A suppressed MOA grid arrives
           here with gridSize 0, which the two legacy guards below would
           mis-report: 'no-distance' also has distance 0 so it would get
           the generic "enter a distance" line with no hint that the grid
           itself vanished, and 'too-fine' has a perfectly good distance
           so it would be told "Grid off" — blaming the user for a
           setting they never touched. This chip is the only live channel
           that can explain a blank preview, so it has to name the cause
           and the way out. */
        if (config.gridState === 'no-distance') {
          readout.classList.add('is-warn');
          text.textContent = config.gridModeLabel +
            ' is an angle — enter a shooting distance or no grid is drawn';
          return;
        }
        if (config.gridState === 'too-fine') {
          readout.classList.add('is-warn');
          /* Two decimals, not one. The floor is 2.0 mm and toFixed(1)
             rounds everything from 1.95 up to "2.0", so 1/4 MOA at 27 m
             (1.9635 mm) announced "is only 2.0 mm ... too fine" while the
             same option at 27.6 m (2.0071 mm) drew without complaint —
             one printed number both refused and accepted, in the one chip
             that exists to explain a blank preview. Self-contradicting
             windows were 1/4 MOA 26.81-27.50 m, 1/2 MOA 13.41-13.75 m,
             1 MOA 6.70-6.88 m.

             And 1 MOA is the coarsest angle on offer, so at the distances
             where IT is refused (under 6.88 m) the old sentence told the
             user to pick the option they had already picked. */
          var coarser = (config.gridMode === 'moa-one')
            ? 'Pick a fixed spacing.'
            : 'Pick 1 MOA or a fixed spacing.';
          text.textContent = config.gridModeLabel + ' is only ' +
            config.gridRefusedMm.toFixed(2) + ' mm at ' + distLabel +
            ' — too fine to print. ' + coarser;
          return;
        }

        if (!distance || distance <= 0) {
          readout.classList.add('is-warn');
          text.textContent = 'Enter a distance to see ' + unit + ' scale on the grid';
          return;
        }
        if (!gridSize || gridSize <= 0) {
          readout.classList.remove('is-warn');
          text.textContent = 'Grid off — no MOA / MIL scale to display at ' + distLabel;
          return;
        }

        readout.classList.remove('is-warn');

        var majorStepMm = gridSize * (config.gridMajorEvery || 5);
        var majorValue = convertMmToUnit(majorStepMm, distance, config.gridLabelUnit);

        /* In MOA mode the sentence runs the other way: the user chose
           the angle and the millimetres are the derived quantity, so
           leading with "14.5 mm ≈ 0.50 MOA" would read backwards. Says
           "labelled", not "(bold)", because the 'range' grid strength
           suppresses major lines entirely (see addGrid) while the label
           step still follows majorEvery.

           It may only claim labels that will actually reach the paper.
           addGridLabels drops every axis number below
           GRID_MIN_LABEL_PITCH_MM, and the checkbox can drop them
           outright — 1/2 MOA at 15 m draws 183 lines on A4 with a 4.4 mm
           label pitch, and this line used to caption that unlabelled
           thicket "labelled every 1.00 MOA". 15 m and 20 m are real
           indoor and air-rifle ranges, not just keystrokes on the way to
           100. When the numbers are suppressed by pitch, say so: it is
           the actionable half of the sentence. When the user turned them
           off, say nothing — the mm-per-MOA statement stands on its own
           and does not need to comment on a control they just set. */
        if (config.gridState === 'ok') {
          var labelNote = '';
          if (config.showGridLabels) {
            labelNote = (majorStepMm >= GRID_MIN_LABEL_PITCH_MM)
              ? '  ·  labelled every ' + formatMoaPrecise(majorValue) + ' ' + unit
              : '  ·  axis labels omitted — too tight to number at ' + distLabel;
          }
          text.textContent =
            config.gridModeLabel + ' = ' + gridSize.toFixed(1) + ' mm at ' + distLabel +
            labelNote;
          return;
        }

        var minorValue = convertMmToUnit(gridSize, distance, config.gridLabelUnit);

        text.textContent =
          gridSize + ' mm ≈ ' + formatMoaPrecise(minorValue) + ' ' + unit +
          '  ·  ' + majorStepMm + ' mm (bold) ≈ ' + formatMoaPrecise(majorValue) + ' ' + unit +
          '  at ' + distLabel;
      }

      function formatMoaPrecise(value) {
        if (value >= 10) return value.toFixed(1);
        if (value >= 1) return value.toFixed(2);
        return value.toFixed(2);
      }

      /* ── Update the marker-readout chip ── */
      function updateMarkerReadout(config, result) {
        var chip = byId('terra-marker-readout');
        if (!chip) return;

        var mode = config.markerMode;
        var actualSpacing = result ? result.markerSpacing : null;
        /* Sticker-guide locks the aim — when markers can't fit alongside
           it, the cause is "the box is too big for any TT preset to
           coexist", not the page. Surfacing that distinction helps users
           pick the right remedy (smaller aim vs bigger paper / portrait). */
        var stickerLocked = (config.aimStyle === 'sticker-guide');

        if (!mode || mode === 'none') {
          chip.classList.remove('is-active');
          chip.textContent = 'No reference markers — target will not be Terra-Impact analysable';
          return;
        }

        if (mode === 'auto') {
          if (actualSpacing) {
            var label = markerLabelForXY(actualSpacing) || 'custom';
            chip.classList.add('is-active');
            chip.textContent = config.pageMarker
              ? 'Auto \u00b7 ' + label + ' page markers \u00b7 ' + PAGE_MARKER_PAPER_NAME[config.pageMarker.key] + ', same as the pre-made sheets'
              : 'Auto \u00b7 ' + label + ' fits best';
          } else {
            chip.classList.remove('is-active');
            chip.textContent = stickerLocked
              ? 'Auto · the locked box is too large for any marker preset to fit — try larger paper or portrait'
              : 'Auto · no marker fits this layout — try larger paper or portrait';
          }
          return;
        }

        if (isPageMarkerKey(mode) && !(config.pageMarker && config.pageMarker.key === mode)) {
          chip.classList.remove('is-active');
          chip.textContent = !PAGE_MARKER_STYLES[config.targetStyle]
            ? MARKER_PRESETS[mode].label + ' marks a whole page \u2014 use TT1-TT5 or Auto when a page has several aim points'
            : MARKER_PRESETS[mode].label + ' is the ' + PAGE_MARKER_PAPER_NAME[mode] + ' page code \u2014 switch to that paper, or use Auto';
          return;
        }

        var requested = MARKER_PRESETS[mode];
        if (!requested) {
          chip.classList.remove('is-active');
          chip.textContent = 'Unknown marker mode';
          return;
        }
        /* Compare by VALUE - spacing pairs are rebuilt per render, so the
           old `actualSpacing === requested.spacing` identity test would now
           never be true and every fitting preset would report "too large". */
        if (markerXYEquals(actualSpacing, markerPresetXY(requested))) {
          chip.classList.add('is-active');
          chip.textContent = config.pageMarker
            ? requested.label + ' page markers \u00b7 ' + PAGE_MARKER_PAPER_NAME[mode]
            : requested.label + ' fits \u00b7 20 mm corner markers';
        } else {
          chip.classList.remove('is-active');
          chip.textContent = stickerLocked
            ? requested.label + ' conflicts with the locked aim — switch to Auto, smaller TT, or larger paper'
            : requested.label + ' too large for this layout — switch to Auto or smaller';
        }
      }

      /* ── Update aim slider bounds and sub-label from actual max ── */
      function updateAimBounds(result, config) {
        var slider = byId('terra-aim-size');
        var numIn = byId('terra-aim-size-value');
        var sub = byId('terra-aim-size-sub');
        if (!slider || !result) return;

        /* Effective scale — sticker-guide bypasses paperScaleFactor in
           getConfig() so the typed mm equals printed mm. We must mirror
           that here, otherwise an 80 mm sticker on A3 (scale 1.16)
           appears as "capped at 80 mm" when it's actually fitting
           exactly, and the slider max attribute gets miscalculated. */
        var scale = (config.aimStyle === 'sticker-guide')
          ? 1
          : paperScaleFactor(config.paperSize);

        /* Convert from printed-mm max back to slider (pre-scale) mm */
        var sliderMax = Math.floor((result.maxAim || 150) / (scale || 1));
        sliderMax = Math.max(20, Math.min(400, sliderMax));

        /* Only update slider max attr if it changed — avoid slider jumping
           while user drags. But ALWAYS keep the number input clamped to
           the current layout max so what's shown matches what's printed. */
        if (parseInt(slider.getAttribute('max'), 10) !== sliderMax) {
          slider.setAttribute('max', String(sliderMax));
          /* Clamp current slider value if we've shrunk below it */
          if (parseFloat(slider.value) > sliderMax) {
            slider.value = String(sliderMax);
          }
        }

        /* Determine the actual printed aim size (after the layout has had
           its say) and convert back to slider/input space. The number
           input is the canonical readout — it MUST match what gets
           printed, otherwise the user reads "400 mm" while the target
           draws a 53 mm aim circle, which is the disjoint behaviour the
           old code allowed. */
        var actualPrintedAim = Math.round(result.effectiveAim || 0);
        var actualPreScale = actualPrintedAim
          ? Math.round(actualPrintedAim / (scale || 1))
          : parseFloat(slider.value) || 0;
        /* Bound to the controls' valid range. The number input goes
           10–400; the slider is dynamic and bounded by sliderMax above. */
        actualPreScale = Math.max(10, Math.min(400, actualPreScale));

        /* Sync slider value if it doesn't match (capped scenario) */
        if (parseFloat(slider.value) !== actualPreScale) {
          slider.value = String(Math.min(actualPreScale, sliderMax));
        }
        /* Sync number input to match — whatever's drawn is what the
           input shows. The number input is in DISPLAY units (mm if
           metric, in if imperial) so we must convert here from the mm
           sync value. Direct .value assignment doesn't fire 'input' or
           'change' events, so this won't trigger an infinite re-render. */
        var unit = getActiveUnit();
        if (numIn) {
          var displayedActual = mmToAimDisplay(actualPreScale, unit);
          if (parseFloat(numIn.value) !== displayedActual) {
            numIn.value = String(displayedActual);
          }
        }

        if (sub) {
          var requestedMm = parseFloat(config.aimSize) || 0;
          var scaledRequested = Math.round(requestedMm * scale);
          /* Helper text uses the active display unit so it reads
             "(max 6.1 in for this layout)" in imperial, not a mm value
             alongside an in input. */
          var unitLabel = (unit === 'imperial') ? 'in' : 'mm';
          if (actualPrintedAim && actualPrintedAim < scaledRequested - 1) {
            sub.textContent = '(capped at ' + mmToAimDisplay(actualPrintedAim, unit) + ' ' + unitLabel + ' by layout)';
          } else {
            sub.textContent = '(max ' + mmToAimDisplay(sliderMax, unit) + ' ' + unitLabel + ' for this layout)';
          }
        }
      }

      /* ── Main render ── */
      function render() {
        try {
          var svg = byId('terra-preview-svg');
          var paper = byId('terra-preview-paper');
          var previewLabel = byId('terra-preview-label');
          var previewStyle = byId('terra-preview-style');
          var aimValue = byId('terra-aim-size-value');
          if (!svg || !paper) return;

          var config = getConfig();
          var dims = config.dims;
          /* Page markers (TT10-TT17) are decided from the PAPER before any
             style draws, because they move the aim to page centre. */
          config.pageMarker = resolvePageMarker(config);
          /* 2026-08-03 resize, then the conditions band moved to the foot.
             Landscape keeps the compact 28mm header; the band now sits just
             ABOVE the notes strip, so the top reserve is the header alone.
             THE BOTTOM STACK IS THE CENTRING LEVER - contentArea, hence the
             aim at its centre, lands on the page centre exactly when
             band + notes = topReserve - 14. The band takes its 9mm out of
             the notes strip: that is what shrinks, per the brief.
             The strip has a 14mm floor so it stays writable. On landscape
             with BOTH band and notes on, 9+14 = 23 exceeds the 14mm the
             centring rule allows, the floor wins, and the aim rides 4.5mm
             high. Every other combination is exact. */
          var headerBottom = config.orientation === 'landscape' ? 28 : 38;
          var topReserve = headerBottom;
          var condBand = config.conditionsRow ? 9 : 0;
          var bottomStack = Math.max(topReserve - 14,
                                     condBand + (config.showNotes ? 14 : 0));
          var footerHeight = Math.max(0, bottomStack - condBand);
          /* footerY stays "bottom bound of the content area" for every draw
             fn and the print-check scale; the notes strip starts below the
             band, so only addFooterStrip takes notesY. */
          var footerY = dims.height - 12 - bottomStack;
          var notesY = footerY + condBand;

          /* Keep the layout-selector field's visibility in sync with the
             current target style (works regardless of preset). */
          updateMultiGridClass(config.targetStyle === 'multi_grid');

          /* headerBottom / topReserve / bottomStack are computed above, next
             to footerHeight, because the strip is derived from them. */
          var contentArea = {
            x: 12,
            y: topReserve,
            width: dims.width - 24,
            height: footerY - topReserve - 2
          };

          svg.setAttribute('viewBox', '0 0 ' + dims.width + ' ' + dims.height);
          svg.setAttribute('width', dims.width + 'mm');
          svg.setAttribute('height', dims.height + 'mm');
          svg.setAttribute('xmlns', svgNs);
          svg.setAttribute('shape-rendering', 'geometricPrecision');
          svg.setAttribute('text-rendering', 'geometricPrecision');
          paper.style.aspectRatio = dims.width + ' / ' + dims.height;
          clearNode(svg);

          addRect(svg, 0, 0, dims.width, dims.height, { fill: '#ffffff' });

          var result = null;
          if (config.targetStyle === 'cold_bore') {
            result = drawColdBore(svg, contentArea, footerY, config);
          } else if (config.targetStyle === 'single') {
            result = drawSingleTarget(svg, {
              x: contentArea.x,
              y: contentArea.y + 8,
              width: contentArea.width,
              /* Bottom reserve = 8 mm: print-check scale band (v39). */
              height: footerY - contentArea.y - 8
            }, config, 'dot', config.pageTitleOverride || 'SINGLE AIM POINT');
          } else if (config.targetStyle === 'diamond') {
            result = drawSingleTarget(svg, {
              x: contentArea.x,
              y: contentArea.y + 8,
              width: contentArea.width,
              /* Bottom reserve = 8 mm: print-check scale band (v39). */
              height: footerY - contentArea.y - 8
            }, config, 'diamond', config.pageTitleOverride || 'DIAMOND HOLD POINT');
          } else if (config.targetStyle === 'zero_sheet') {
            result = drawZeroSheet(svg, contentArea, footerY, config);
          } else if (config.targetStyle === 'multi_grid') {
            result = drawMultiGrid(svg, contentArea, footerY, config);
          }

          /* Print-check scale: 100 mm horizontal ruler at the bottom of
             every page so the user can verify their printer didn't
             apply fit-to-page scaling. Drawn in actual SVG mm — the
             SVG viewBox is 1:1 with paper mm — so a 100 mm scale
             measures exactly 100 mm on paper at 100% print. Renders
             in the 8 mm band reserved by every target style above.
             v40: switches to a 4-inch ruler when imperial units are
             active so the user reads the scale in their working unit. */
          if (config.pageMarker && result && result.markerSpacing) {
            addPageMarkers(svg, dims, config.pageMarker.spacing);
          }

          addPrintCheckScale(svg, contentArea, footerY, config.unitSystem);

          /* Preview frame's top-right label tracks the active PRESET, not
             the target style — so the label reads "Splatter Zero" not
             "100m zero", and "Custom" not "Diamond hold point". Strip the
             "•" custom-has-data marker if present. */
          if (previewStyle) {
            var presetSel = byId('terra-preset-select');
            var label = '';
            if (presetSel && presetSel.options[presetSel.selectedIndex]) {
              label = presetSel.options[presetSel.selectedIndex].textContent.replace(/\s*\u2022\s*$/, '').trim();
            }
            previewStyle.textContent = label;
          }

          /* Resolve marker label from the actual drawn marker spacing
             so the page header can advertise "TT3" etc. */
          var markerLabel = (result && result.markerSpacing)
            ? markerLabelForXY(result.markerSpacing)
            : null;
          config.markerLabel = markerLabel; /* passed to addHeader, and to the
             QR as m=TT#, so a scan pre-selects the matching preset */

          addHeader(svg, dims, config);

          /* Conditions band sits just above the notes strip, 1mm inset top
             and bottom inside its 9mm slot (7mm row + 2mm air). */
          if (config.conditionsRow) {
            addConditionsRow(svg, dims, footerY + 1, pageEdgeInset(config));
          }

          /* v54: QR drawn on every variant including Custom. The QR
             payload encodes rifle / calibre / distance / session so
             Terra-Impact can pre-fill those when scanned — that's
             useful even when the spacing was custom rather than a
             named preset. The marker-label parameter (m=) is omitted
             when no preset matches (markerLabel is null for Custom),
             which Terra-Impact handles gracefully. */
          drawQrCode(svg, dims, config);

          if (config.showNotes) {
            addFooterStrip(svg, dims, notesY, footerHeight, pageEdgeInset(config));
          }

          previewLabel.textContent = config.paperSize + ' ' + config.orientation;
          /* Mirror the canonical aim value onto both controls so they stay
             visually in sync regardless of which the user touched. The
             slider clamps to its own min/max attribute when assigned a
             value outside that range — that's the desired visual behaviour
             when the number input contains a value beyond the slider's
             scrubbing range (eg 200 mm for a custom large sticker). */
          aimValue.value = config.aimSize;
          var aimSliderEl = byId('terra-aim-size');
          if (aimSliderEl) aimSliderEl.value = String(config.aimSize);

          /* Drive the supporting UI chips from the render result */
          updateAimBounds(result, config);
          updateMoaReadout(config);
          updateMarkerReadout(config, result);
        } catch (error) {
          console.error('Terra target customizer render error', error);
          var svg = byId('terra-preview-svg');
          if (svg) {
            clearNode(svg);
            svg.setAttribute('viewBox', '0 0 210 297');
            addRect(svg, 0, 0, 210, 297, { fill: '#ffffff' });
            appendText(svg, { x: 105, y: 60, 'text-anchor': 'middle', 'font-size': 9, 'font-weight': '800', fill: '#1b241d' }, 'Preview failed to render');
            appendText(svg, { x: 105, y: 74, 'text-anchor': 'middle', 'font-size': 5, fill: '#5f695f' }, 'Use the plain fallback file if this persists.');
          }
        }
      }

      /* ── UI state helpers ── */
      function setActive(groupSelector, matchAttr, value) {
        forEachNode(root().querySelectorAll(groupSelector), function(button) {
          var isActive = button.getAttribute(matchAttr) === value;
          button.classList.toggle('active', isActive);
          /* Mirror visual active state to the accessibility tree so
             screen reader users hear "pressed" / "not pressed" on each
             toggle button in a choice grid (v42-a11y). */
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      }

      function applyPreset(presetName) {
        var sel = byId('terra-preset-select');
        if (presetName === 'custom') {
          var custom = loadCustomPreset() || presets.custom;
          applyPresetData(custom);
          if (sel) sel.value = 'custom';
          updateCustomModeClass(true);
          render();
          return;
        }

        var preset = presets[presetName];
        if (!preset) return;
        applyPresetData(preset);
        if (sel) sel.value = presetName;
        updateCustomModeClass(false);
        render();
      }

      /* Toggle the is-custom-active class on the section root so CSS
         can hide/show panels appropriately. */
      function updateCustomModeClass(isCustom) {
        var r = root();
        if (!r) return;
        r.classList.toggle('is-custom-active', !!isCustom);
      }

      /* Toggle the is-multi-grid-active class so the layout selector
         field only shows when the multi-aim-grid target style is picked. */
      function updateMultiGridClass(isMultiGrid) {
        var r = root();
        if (!r) return;
        r.classList.toggle('is-multi-grid-active', !!isMultiGrid);
      }

      /* Last-resort recovery when a preset asks for a grid option that
         isn't in the list. Assigning a <select>.value that matches no
         <option> is not an error — the element quietly goes to
         selectedIndex -1 and value '', and parseFloat('') is NaN, which
         resolveGridSpacing turns into a 10 mm grid. The user then gets a
         10 mm grid under a header advertising something else.

         This is a PRE-EXISTING bug, reproducible before any MOA work:
         switch to imperial (list becomes 0 / 6.35 / 12.7 / 25.4), then
         pick Splatter Zero or Ethical Range Rings (both gridSize 20).
         No named preset carries unitSystem, so the list is never rebuilt
         for them, '20' matches nothing, and every named preset's grid
         spacing is silently ignored in imperial mode. Nearest-by-density
         gives 25.4 mm there, and the header then tells the truth.

         'None' (0) is excluded as a candidate: it is an off switch, not
         a density, and a preset asking for a fine grid must never land
         on "no grid". A wanted value of '0' matches by identity anyway,
         so it never reaches here. */
      function selectNearestGridOption(sel, wantedValue) {
        var wantedMm = parseFloat(wantedValue);
        var bestIndex = -1;
        var bestDelta = Infinity;
        var i;
        if (!isNaN(wantedMm)) {
          for (i = 0; i < sel.options.length; i += 1) {
            var mmValue = parseFloat(sel.options[i].value);
            if (isNaN(mmValue) || mmValue <= 0) continue; /* MOA token or None */
            var delta = Math.abs(mmValue - wantedMm);
            if (delta < bestDelta) {
              bestDelta = delta;
              bestIndex = i;
            }
          }
        }
        if (bestIndex === -1) {
          /* Non-numeric wanted value — an unknown MOA token from a save
             written by a future build. Fall back to the unit default
             rather than leaving the select in the '' state. */
          var fallbackMm = (getActiveUnit() === 'imperial') ? 12.7 : 10;
          for (i = 0; i < sel.options.length; i += 1) {
            if (parseFloat(sel.options[i].value) === fallbackMm) {
              bestIndex = i;
              break;
            }
          }
        }
        if (bestIndex >= 0) sel.selectedIndex = bestIndex;
      }

      /* Snap the aim slider to its current layout max (set by updateAimBounds
         during the last render) and re-render so the change is visible. */
      function applyPresetData(preset) {
        if (preset.targetStyle) byId('terra-target-style').value = preset.targetStyle;
        if (preset.paperSize) byId('terra-paper-size').value = preset.paperSize;
        if (preset.orientation) byId('terra-orientation').value = preset.orientation;
        /* gridMode wins when it names an MOA option, because gridSize
           stores the mm ACTUALLY DRAWN — for a suppressed MOA grid that
           is 0, and restoring 0 would silently turn the grid off. Old
           saves have no gridMode and fall through to the mm value, which
           is exactly what they meant. */
        var gridSelectEl = byId('terra-grid-size');
        if (gridSelectEl) {
          var wantedGrid = null;
          if (preset.gridMode && preset.gridMode !== 'abs') {
            wantedGrid = String(preset.gridMode);
          } else if (preset.gridSize !== undefined && preset.gridSize !== null) {
            wantedGrid = String(preset.gridSize);
          }
          if (wantedGrid !== null) {
            gridSelectEl.value = wantedGrid;
            /* Verify: an unmatched assignment fails silently. */
            if (gridSelectEl.selectedIndex === -1 || gridSelectEl.value === '') {
              selectNearestGridOption(gridSelectEl, wantedGrid);
            }
          }
        }

        /* Unit system FIRST (was at the bottom pre-v40) so subsequent
           writes that need a unit context — namely the aim size number
           input which now displays in the active unit — happen with
           the correct unit already active. Named presets don't carry
           unitSystem; only Custom (which the user can save in either
           system). */
        if (preset.unitSystem) {
          var prevUnit = getActiveUnit();
          setActive('#terra-unit-grid-' + sectionId + ' .terra-choice-button', 'data-unit', preset.unitSystem);
          refreshUnitDependentControls(preset.unitSystem, prevUnit);
        }

        /* Aim size — preset.aimSize is ALWAYS stored as mm. The slider
           takes raw mm; the number input takes the display-unit value
           via setAimSizeDisplay (which checks the now-correct active
           unit). This replaces a pre-v40 bug where switching to an
           imperial preset would leave the number input showing the mm
           value as if it were inches. */
        if (preset.aimSize) {
          byId('terra-aim-size').value = String(preset.aimSize);
          setAimSizeDisplay(preset.aimSize);
        }

        byId('terra-distance').value = preset.distance || '';
        byId('terra-notes').value = preset.notes || '';
        byId('terra-show-notes').checked = preset.showNotes !== false;
        if (preset.rifle !== undefined) byId('terra-rifle').value = preset.rifle;
        if (preset.calibre !== undefined) byId('terra-calibre').value = preset.calibre;
        if (preset.showGridLabels !== undefined) byId('terra-show-grid-labels').checked = !!preset.showGridLabels;
        if (preset.gridLabelUnit) byId('terra-grid-label-unit').value = preset.gridLabelUnit;
        setActive('#terra-grid-strength-grid-' + sectionId + ' .terra-choice-button', 'data-grid-strength', preset.gridStrength || 'field');
        setActive('#terra-aim-style-grid-' + sectionId + ' .terra-choice-button', 'data-aim-style', preset.aimStyle || 'dot-only');
        setActive('#terra-marker-grid-' + sectionId + ' .terra-choice-button', 'data-marker', preset.markerMode || 'auto');
        setActive('#terra-purpose-grid-' + sectionId + ' .terra-choice-button', 'data-purpose', preset.purpose || 'zero');
        setActive('#terra-multi-grid-layout-' + sectionId + ' .terra-choice-button', 'data-multi-grid-layout', preset.multiGridLayout || '2x2');

        /* Field extras */
        setActive('#terra-holdover-grid-' + sectionId + ' .terra-choice-button', 'data-holdover', preset.holdover || 'off');
        if (preset.ethicalGame !== undefined) byId('terra-ethical-game').value = preset.ethicalGame || 'off';
        if (preset.conditionsRow !== undefined) byId('terra-conditions-row').checked = !!preset.conditionsRow;

        /* Session name */
        if (preset.sessionName !== undefined) byId('terra-session-name').value = preset.sessionName || '';

        /* Runtime-only state (not a user-visible control) */
        runtimeState.moaRings = preset.moaRings | 0;
        runtimeState.multiPage = preset.multiPage || 1;
        runtimeState.multiPageTitles = preset.multiPageTitles || null;
        /* Preset-level page title (e.g. 'TERRA-80MM SPLATTER' for splatter_zero).
           Multi-page rendering will temporarily override this per page and
           restore it afterwards, so single-page presets keep their label. */
        runtimeState.pageTitleOverride = preset.pageTitle || null;

        /* MOA rings toggle — binary on/off based on the preset's
           runtime default. Any non-zero value means "rings on". */
        var moaRingsState = runtimeState.moaRings >= 999 ? 'on' : 'off';
        setActive('#terra-moa-rings-grid-' + sectionId + ' .terra-choice-button', 'data-moa-rings', moaRingsState);

        syncDistanceChips(preset.distance || '');
      }

      /* Highlight the distance chip that matches the current text input */
      function syncDistanceChips(distanceText) {
        var root_ = root();
        if (!root_) return;
        var normalised = (distanceText || '').trim().toLowerCase().replace(/\s+/g, '');
        var unit = getActiveUnit();
        var attrName = unit === 'imperial' ? 'data-distance-imperial' : 'data-distance-metric';
        var matched = false;
        forEachNode(root_.querySelectorAll('#terra-distance-chips-' + sectionId + ' .terra-choice-button'), function(btn) {
          var chipValue = (btn.getAttribute(attrName) || '').toLowerCase();
          var isMatch = chipValue === normalised;
          btn.classList.toggle('active', isMatch);
          /* Sync aria-pressed for screen readers (v42-a11y). */
          btn.setAttribute('aria-pressed', isMatch ? 'true' : 'false');
          if (isMatch) matched = true;
        });
        if (!matched) {
          forEachNode(root_.querySelectorAll('#terra-distance-chips-' + sectionId + ' .terra-choice-button'), function(btn) {
            btn.classList.remove('active');
            btn.setAttribute('aria-pressed', 'false');
          });
        }
      }

      /* (i) Re-label the distance chips and grid-spacing select when the
         user switches between metric and imperial units. Internal values
         stay in mm — labels just swap. Also converts the currently-typed
         distance value. */
      function refreshUnitDependentControls(unit, oldUnit) {
        var root_ = root();
        if (!root_) return;
        /* Default oldUnit to current unit (no conversion happens —
           backward-compatible for early-init paths). */
        oldUnit = oldUnit || unit;

        /* (a) Aim point size — convert displayed value, update min/max,
           swap the suffix span. Read input value AS oldUnit, write back
           AS new unit. Slider min/max stays in mm (slider is always
           internal mm; only the number input shows display unit). */
        var aimInput = byId('terra-aim-size-value');
        if (aimInput) {
          var oldDisplay = parseFloat(aimInput.value);
          if (!isNaN(oldDisplay)) {
            var mm = aimDisplayToMm(oldDisplay, oldUnit);
            if (!isNaN(mm)) {
              aimInput.value = String(mmToAimDisplay(mm, unit));
            }
          }
          if (unit === 'imperial') {
            aimInput.setAttribute('min', '0.4');
            aimInput.setAttribute('max', '16');
            aimInput.setAttribute('step', '0.1');
          } else {
            aimInput.setAttribute('min', '10');
            aimInput.setAttribute('max', '400');
            aimInput.setAttribute('step', '1');
          }
        }
        var aimUnitSpan = byId('terra-aim-size-unit');
        if (aimUnitSpan) {
          aimUnitSpan.textContent = (unit === 'imperial') ? 'in' : 'mm';
        }

        /* (b) Ethical-range rings — each option has both labels stored
           as data attributes; just swap textContent. The value attribute
           (the ETHICAL_GAME key) is never touched, so config.ethicalGame
           stays stable across the toggle. */
        var ethicalSelect = byId('terra-ethical-game');
        if (ethicalSelect) {
          var attrName = (unit === 'imperial') ? 'data-label-imperial' : 'data-label-metric';
          forEachNode(ethicalSelect.options, function(opt) {
            var newLabel = opt.getAttribute(attrName);
            if (newLabel) opt.textContent = newLabel;
          });
        }

        /* (c) Distance chips */
        forEachNode(root_.querySelectorAll('#terra-distance-chips-' + sectionId + ' .terra-choice-button'), function(btn) {
          if (unit === 'imperial') {
            var impVal = btn.getAttribute('data-distance-imperial') || '';
            btn.textContent = impVal.replace('yd', ' yd');
          } else {
            var metVal = btn.getAttribute('data-distance-metric') || '';
            btn.textContent = metVal.replace('m', ' m');
          }
        });

        /* Repopulate grid-spacing select.
           NOTE: sections/terra-build.liquid still ships the old
           four-option metric list as static markup. It never survives —
           init() calls this function unconditionally before the user can
           touch anything, and the loop below wipes every child. The
           Liquid seed governs only the pre-init flash; it should be
           brought into line next time that file is open anyway.

           The MOA block appears in BOTH unit systems on purpose. MOA is
           an angle; a turret is marked in MOA whether the shooter
           measures groups in millimetres or inches, and Greg's request
           was specifically that the METRIC list fails MOA scopes.
           Restricting it to imperial would miss the person who asked. */
        var gridSelect = byId('terra-grid-size');
        if (gridSelect) {
          var previousValue = gridSelect.value;
          var rawPrev = parseFloat(previousValue);
          var previousMm = isNaN(rawPrev) ? 10 : rawPrev;
          while (gridSelect.firstChild) gridSelect.removeChild(gridSelect.firstChild);

          var opts = (unit === 'imperial')
            ? [
                { value: '6.35',  label: '1/4 in' },
                { value: '12.7',  label: '1/2 in' },
                { value: '25.4',  label: '1 in' }
              ]
            : [
                { value: '5',  label: '5 mm' },
                { value: '10', label: '10 mm' },
                { value: '20', label: '20 mm' }
              ];

          var targetDefault = (unit === 'imperial') ? 12.7 : 10;
          var matched = false;

          /* "None" stays a bare option above the groups — it is neither
             a linear nor an angular spacing, it's the off switch. */
          var noneOpt = document.createElement('option');
          noneOpt.value = '0';
          noneOpt.textContent = 'None (no grid)';
          if (previousValue === '0') {
            noneOpt.selected = true;
            matched = true;
          }
          gridSelect.appendChild(noneOpt);

          var absGroup = document.createElement('optgroup');
          absGroup.label = (unit === 'imperial') ? 'Inches' : 'Millimetres';
          for (var i = 0; i < opts.length; i += 1) {
            var opt = document.createElement('option');
            opt.value = opts[i].value;
            opt.textContent = opts[i].label;
            /* Identity first. This is what lets an MOA token survive the
               five paths that rebuild this list — init, the unit toggle,
               a preset carrying unitSystem, a URL param, and a storage
               event fired by ANOTHER TAB. It is also strictly better for
               the absolute options: '10' re-selects '10' exactly on a
               same-unit rebuild instead of relying on a float compare. */
            if (!matched && opts[i].value === previousValue) {
              opt.selected = true;
              matched = true;
            }
            absGroup.appendChild(opt);
          }
          gridSelect.appendChild(absGroup);

          /* The group label carries the precondition. A distance-bearing
             option label ("1/2 MOA = 14.5 mm") would have to be rebuilt
             on every distance keystroke, and both restore paths write
             the unit BEFORE the distance — applyPresetData at the unit
             block above vs the distance write below it, applyUrlParams
             likewise — so any label computed at build time would quote
             the PREVIOUS preset's distance. Static text, no trap. */
          var moaGroup = document.createElement('optgroup');
          moaGroup.label = 'MOA — needs a distance';
          for (var m = 0; m < GRID_MOA_ORDER.length; m += 1) {
            var token = GRID_MOA_ORDER[m];
            var moaOpt = document.createElement('option');
            moaOpt.value = token;
            moaOpt.textContent = GRID_MOA_OPTIONS[token].label;
            if (!matched && token === previousValue) {
              moaOpt.selected = true;
              matched = true;
            }
            moaGroup.appendChild(moaOpt);
          }
          gridSelect.appendChild(moaGroup);

          if (!matched) {
            /* Cross-unit fallback, unchanged in spirit: try to preserve
               approximate grid density by mm. MOA tokens parseFloat to
               NaN and are skipped — they were already caught by identity
               if they were the previous choice. */
            forEachNode(gridSelect.options, function(o) {
              if (matched) return;
              var mmValue = parseFloat(o.value);
              if (isNaN(mmValue)) return;
              if (Math.abs(mmValue - previousMm) < 0.1) {
                o.selected = true;
                matched = true;
              }
            });
          }
          if (!matched) {
            /* Pick sensible default */
            forEachNode(gridSelect.options, function(o) {
              if (parseFloat(o.value) === targetDefault) o.selected = true;
            });
          }
        }

        /* Convert the typed distance if possible */
        var distInput = byId('terra-distance');
        if (distInput && distInput.value) {
          distInput.value = convertDistanceText(distInput.value, unit);
        }
        syncDistanceChips(distInput ? distInput.value : '');
      }

      /* Convert a distance text between units. "100m" -> "109yd", "100yd" -> "91m"
         Shares parseDistanceMetres' number normaliser: this function had
         its own copy of the decimal-comma replace and its own copy of the
         thousands-separator bug, and here the damage was worse — a unit
         toggle REWRITES the field, so "1,000m" came back as "1yd" and the
         user's range was gone, not merely misread.
         An untagged value still passes through unconverted: this runs on
         init and on preset apply with oldUnit === unit (see
         refreshUnitDependentControls), where rewriting a bare number
         would corrupt it. */
      function convertDistanceText(text, toUnit) {
        var raw = normaliseTypedNumber(text);
        var match = raw.match(/([0-9]+(?:\.[0-9]+)?)/);
        if (!match) return text;
        var amount = parseFloat(match[1]);
        if (isNaN(amount)) return text;

        var isYards = raw.indexOf('yd') !== -1 || raw.indexOf('yard') !== -1;
        var isMetres = !isYards && (raw.indexOf('m') !== -1 || raw.indexOf('km') !== -1);

        if (toUnit === 'imperial') {
          if (isYards) return text; /* already imperial */
          if (isMetres) return Math.round(amount * 1.0936) + 'yd';
        } else {
          if (isMetres) return text;
          if (isYards) return Math.round(amount * 0.9144) + 'm';
        }
        return text;
      }

      /* ── Print / PDF ── */
      function ensurePrintHost() {
        var hostId = 'terra-print-host-' + sectionId;
        var host = document.getElementById(hostId);
        if (!host) {
          host = document.createElement('div');
          host.id = hostId;
          host.style.display = 'none';
          document.body.appendChild(host);
        }
        return host;
      }

      function getNamedPrintSize(paperSize) {
        switch (paperSize) {
          case 'A4': return 'A4';
          case 'A3': return 'A3';
          case 'LETTER': return 'letter';
          case 'TABLOID': return 'tabloid';
          default: return '';
        }
      }

      function ensurePrintPageStyle(paperSize, orientation, widthMm, heightMm) {
        var styleId = 'terra-print-page-style-' + sectionId;
        var styleNode = document.getElementById(styleId);
        if (!styleNode) {
          styleNode = document.createElement('style');
          styleNode.id = styleId;
          /* MUST be appended to BODY, not head. Shopify renders a section's own
             <style> inside the BODY, so a node in <head> is EARLIER in document
             order and loses every tie to it. @page descriptors and equally-
             !important rules resolve by document order, so a head-mounted node had
             its `size: <paper> <orientation>` overridden by the section's static
             `@page { size: auto }`, and its `html, body { width: Nmm !important }`
             overridden by the static `width: auto !important`. Net effect: paper
             size and orientation silently ignored the preset entirely.
             Appending to body puts this last, so it wins. */
          document.body.appendChild(styleNode);
        }
        var namedSize = getNamedPrintSize(paperSize);
        var pageSizeRule = namedSize ? (namedSize + ' ' + orientation) : (widthMm + 'mm ' + heightMm + 'mm');
        styleNode.textContent = '@media print { @page { size: ' + pageSizeRule + '; margin: 0; } html, body { width: ' + widthMm + 'mm !important; height: ' + heightMm + 'mm !important; } #terra-print-host-' + sectionId + ' { width: ' + widthMm + 'mm !important; height: ' + heightMm + 'mm !important; max-width: ' + widthMm + 'mm !important; max-height: ' + heightMm + 'mm !important; } }';
        return styleNode;
      }

      /* ── Email capture (Klaviyo) ── (v46)
         Hooks into the public client-subscriptions endpoint with the
         merchant's public key and list ID. POSTs the user's email plus
         a snapshot of their current target configuration as profile
         properties. The properties enable Klaviyo segmentation: e.g.
         "users who built Splatter Zero on TT4 spacing" is a campaign
         audience for the Terra-Field650 + splatter sticker bundle.

         The endpoint accepts CORS POSTs from any origin (it's the
         documented browser-callable endpoint). Public keys are NOT
         secrets — they're company identifiers. List IDs aren't
         secrets either. So both can safely be embedded in the page. */
      function isValidEmail(s) {
        if (typeof s !== 'string') return false;
        s = s.trim();
        if (s.length < 5 || s.length > 254) return false;
        /* Pragmatic regex — catches obvious typos without trying to
           encode the full RFC 5322 grammar. Klaviyo will reject
           anything malformed it accepts past this filter. */
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(s);
      }

      function setEmailCaptureStatus(kind, message) {
        var el = byId('terra-email-capture-status');
        if (!el) return;
        if (!kind) {
          el.hidden = true;
          el.removeAttribute('data-status');
          el.textContent = '';
          return;
        }
        el.hidden = false;
        el.setAttribute('data-status', kind);
        el.textContent = message;
      }

      function buildEmailCaptureProperties() {
        /* Snapshot the current configuration so Klaviyo gets the
           preset metadata as profile properties — these become
           Klaviyo segmentation dimensions. snake_case matches Klaviyo
           convention. */
        var config = getConfig();
        return {
          terra_build_preset:        config.activePreset || 'custom',
          terra_build_target_style:  config.targetStyle || '',
          terra_build_paper_size:    config.paperSize || '',
          terra_build_orientation:   config.orientation || '',
          terra_build_distance:      config.distance || '',
          terra_build_marker_mode:   config.markerMode || '',
          terra_build_holdover:      config.holdover || '',
          terra_build_ethical_game:  config.ethicalGame || '',
          terra_build_calibre:       config.calibre || '',
          terra_build_aim_size_mm:   config.aimSize | 0,
          terra_build_unit_system:   config.unitSystem || '',
          /* `| 0` truncates — 6.35 has always reported as 6 — so a
             derived 7.2722 would land as 7 and be indistinguishable from
             an absolute 7 mm grid. Left alone rather than "fixed",
             because any Klaviyo segment already built on it would break;
             the companion mode property is what actually answers "did
             anyone use the MOA grids?". */
          terra_build_grid_size_mm:  config.gridSize | 0,
          terra_build_grid_mode:     config.gridMode || 'abs',
          terra_capture_source:      'terra-build-customizer'
        };
      }

      function submitEmailCapture() {
        var input = byId('terra-email-capture-input');
        var submitBtn = byId('terra-email-capture-submit');
        if (!input || !submitBtn) return;

        var email = (input.value || '').trim();
        if (!isValidEmail(email)) {
          setEmailCaptureStatus('error', 'That email looks malformed — please check and try again.');
          input.focus();
          return;
        }
        if (!KLAVIYO_CFG.publicKey || !KLAVIYO_CFG.listId) {
          /* Defence-in-depth — the Liquid `if` guard on the markup
             should already have prevented the form from rendering, so
             this branch is unreachable in normal operation. If it ever
             fires, something's wrong with the theme settings. */
          setEmailCaptureStatus('error', 'Email capture is not configured. Please print directly.');
          return;
        }

        var originalLabel = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Sending\u2026';
        setEmailCaptureStatus(null);

        var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' +
                       encodeURIComponent(KLAVIYO_CFG.publicKey);
        var payload = {
          data: {
            type: 'subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: buildEmailCaptureProperties()
                  }
                }
              }
            },
            relationships: {
              list: { data: { type: 'list', id: KLAVIYO_CFG.listId } }
            }
          }
        };

        var restoreSubmitButton = function() {
          submitBtn.disabled = false;
          submitBtn.textContent = originalLabel;
        };

        fetch(endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            /* Klaviyo requires API versioning via the `revision`
               header. Pin to a known-good version so future API
               changes don't break this submission flow silently. */
            'revision': '2024-10-15'
          },
          body: JSON.stringify(payload)
        }).then(function(response) {
          /* 202 Accepted is the documented success response for
             client/subscriptions. Treat any 2xx as success defensively. */
          if (response.ok || response.status === 202) {
            setEmailCaptureStatus('success', KLAVIYO_CFG.successText);
            input.value = '';
            /* Auto-collapse after a short pause so the form doesn't
               keep prompting after a successful capture. */
            setTimeout(function() {
              var form = byId('terra-email-capture-form');
              var toggle = byId('terra-email-capture-toggle');
              if (form) form.hidden = true;
              if (toggle) toggle.setAttribute('aria-expanded', 'false');
            }, 2400);
          } else if (response.status === 429) {
            setEmailCaptureStatus('error', 'Too many requests just now — please try again in a moment.');
          } else {
            setEmailCaptureStatus('error', 'Submission failed. Please try again.');
          }
          restoreSubmitButton();
        }).catch(function() {
          setEmailCaptureStatus('error', 'Could not reach the server. Check your connection and try again.');
          restoreSubmitButton();
        });
      }

      function bindEmailCapture() {
        var toggle = byId('terra-email-capture-toggle');
        var form = byId('terra-email-capture-form');
        if (!toggle || !form) return; /* not configured — no markup */

        toggle.addEventListener('click', function() {
          var willBeOpen = !!form.hidden;
          form.hidden = !willBeOpen;
          toggle.setAttribute('aria-expanded', willBeOpen ? 'true' : 'false');
          setEmailCaptureStatus(null);
          if (willBeOpen) {
            var input = byId('terra-email-capture-input');
            if (input) setTimeout(function() { input.focus(); }, 50);
          }
        });

        var submitBtn = byId('terra-email-capture-submit');
        if (submitBtn) submitBtn.addEventListener('click', submitEmailCapture);

        /* Submit on Enter from the input — the form isn't a real
           <form> element so the browser doesn't do this for free. */
        var input = byId('terra-email-capture-input');
        if (input) {
          input.addEventListener('keydown', function(e) {
            if (e.key === 'Enter') {
              e.preventDefault();
              submitEmailCapture();
            }
          });
        }
      }

      function printTarget() {
        var previewSvg = byId('terra-preview-svg');
        if (!previewSvg) return;

        var config = getConfig();
        var dims = config.dims;
        var host = ensurePrintHost();
        var pages = Math.max(1, config.multiPage | 0);
        var titles = runtimeState.multiPageTitles || [];
        var pageStyle = ensurePrintPageStyle(config.paperSize, config.orientation, dims.width, dims.height);

        host.innerHTML = '';
        host.style.display = 'block';
        host.style.width = dims.width + 'mm';
        host.style.height = dims.height + 'mm';
        host.style.maxWidth = dims.width + 'mm';
        host.style.maxHeight = 'none';

        var originalTitleOverride = runtimeState.pageTitleOverride;

        for (var p = 0; p < pages; p += 1) {
          /* (g) Set page-specific title override, then re-render the
             preview SVG. We clone it into the print host and continue. */
          runtimeState.pageTitleOverride = titles[p] || null;
          render();
          var svg = byId('terra-preview-svg');

          var pageDiv = document.createElement('div');
          pageDiv.className = 'terra-print-page';
          pageDiv.style.width = dims.width + 'mm';
          pageDiv.style.height = dims.height + 'mm';
          pageDiv.style.pageBreakAfter = (p < pages - 1) ? 'always' : 'auto';
          pageDiv.style.breakAfter = (p < pages - 1) ? 'page' : 'auto';

          var clone = svg.cloneNode(true);
          clone.setAttribute('width', dims.width + 'mm');
          clone.setAttribute('height', dims.height + 'mm');
          clone.setAttribute('viewBox', '0 0 ' + dims.width + ' ' + dims.height);
          /* Print fidelity: the page wrapper above is sized to dims.width
             × dims.height mm exactly, matching the SVG viewBox. Both
             'meet' and 'none' produce identical output when aspect ratios
             agree, but 'meet' is safer against any browser-level pixel
             rounding that would non-uniformly stretch with 'none' — and
             non-uniform stretch on exact-size targets (the 80 mm splatter
             box, 200 mm deer ring) would print incorrectly to scale. */
          clone.setAttribute('preserveAspectRatio', 'xMidYMid meet');
          clone.style.width = '100%';
          clone.style.height = '100%';
          clone.style.display = 'block';
          clone.style.margin = '0';
          pageDiv.appendChild(clone);
          host.appendChild(pageDiv);
        }

        /* Restore preview to its normal state */
        runtimeState.pageTitleOverride = originalTitleOverride;
        render();

        requestAnimationFrame(function() {
          requestAnimationFrame(function() {
            window.print();
          });
        });

        setTimeout(function() {
          host.style.display = 'none';
          host.innerHTML = '';
          if (pageStyle) pageStyle.remove();
        }, 800);
      }

      /* ── Mobile preview toggle ── */
      var mobilePreviewVisible = false;

      function toggleMobilePreview() {
        var controls = byId('terra-controls');
        var preview = byId('terra-preview-wrap');
        var toggleText = byId('terra-mobile-toggle-text');
        var toggleIcon = byId('terra-mobile-toggle-icon');
        if (!controls || !preview) return;

        mobilePreviewVisible = !mobilePreviewVisible;

        if (mobilePreviewVisible) {
          controls.classList.add('is-hidden');
          preview.classList.add('is-visible');
          if (toggleText) toggleText.textContent = 'Show Controls';
          if (toggleIcon) toggleIcon.innerHTML = '&#9998;';
        } else {
          controls.classList.remove('is-hidden');
          preview.classList.remove('is-visible');
          if (toggleText) toggleText.textContent = 'Show Preview';
          if (toggleIcon) toggleIcon.innerHTML = '&#9678;';
        }
      }

      /* ── Auto-save custom preset on changes ── */
      function onUserChange() {
        render();
        /* (f) Paper size and orientation changes are allowed within any
           preset without auto-promoting to Custom. Same for the Units
           toggle and distance changes — these are "view" changes that
           don't change the preset's character. */
        var sel = byId('terra-preset-select');
        var activeValue = sel ? sel.value : null;
        if (activeValue && activeValue !== 'custom') {
          if (isNonPromotingChange()) {
            saveCustomPreset();
            return;
          }
          if (sel) sel.value = 'custom';
          updateCustomModeClass(true);
          /* Lock the page title to the Custom-mode label so a user who
             promoted from (say) Splatter Zero doesn't keep that preset's
             title once they're customising. */
          runtimeState.pageTitleOverride = 'USER CUSTOM TARGET';
          /* Re-render once now that custom-only panels are visible and
             marker mode has been forced to 'none'. */
          render();
        }
        saveCustomPreset();
      }

      /* Flag set by input handlers that should NOT auto-promote. Cleared
         synchronously after onUserChange runs. */
      var _nonPromotingChange = false;
      function isNonPromotingChange() {
        var was = _nonPromotingChange;
        _nonPromotingChange = false;
        return was;
      }
      function markNonPromoting() {
        _nonPromotingChange = true;
      }

      /* ── Event binding ── */
      function bind() {
        var sectionRoot = root();
        if (!sectionRoot || sectionRoot.dataset.terraBound === 'true') return;
        sectionRoot.dataset.terraBound = 'true';

        forEachNode(sectionRoot.querySelectorAll('select, input'), function(node) {
          /* The preset <select> is handled by its own dedicated listener
             below — applyPreset() does its own render + state setup, so
             we mustn't also trigger onUserChange (which would re-render
             and incorrectly auto-promote to Custom). */
          if (node.classList.contains('terra-preset-select')) return;
          /* The aim-size slider needs its own dedicated handler that
             mirrors its value onto the number input BEFORE onUserChange
             fires, otherwise render() would read the (still stale)
             number input value and snap the slider back to its old
             position. See dedicated handler below. */
          if (node.id === 'terra-aim-size-' + sectionId + '') return;

          var isNonPromotingControl = (
            node.id === 'terra-paper-size-' + sectionId + '' ||
            node.id === 'terra-orientation-' + sectionId + '' ||
            node.id === 'terra-distance-' + sectionId + ''
          );
          node.addEventListener('input', function() {
            if (isNonPromotingControl) markNonPromoting();
            onUserChange();
          });
          node.addEventListener('change', function() {
            if (isNonPromotingControl) markNonPromoting();
            onUserChange();
          });
        });

        /* Dedicated change listener for the preset select. */
        var presetSelect = byId('terra-preset-select');
        if (presetSelect) {
          presetSelect.addEventListener('change', function() {
            applyPreset(presetSelect.value);
          });
        }

        /* Aim-size slider mirrors live onto the number input on every
           drag tick. Without this push, render() would read the unchanged
           number-input value and override the slider's freshly-changed
           position back to the old value. The slider stores raw mm; the
           number input is in display unit (mm or in) — convert on the
           way through, otherwise dragging in imperial would write the
           mm value into an inches input. v40. */
        var aimSliderEl = byId('terra-aim-size');
        var aimNumberEl = byId('terra-aim-size-value');
        if (aimSliderEl && aimNumberEl) {
          aimSliderEl.addEventListener('input', function() {
            var mm = parseFloat(aimSliderEl.value) || 0;
            aimNumberEl.value = String(mmToAimDisplay(mm, getActiveUnit()));
            onUserChange();
          });
        }

        /* Keep distance chips in sync when the user types a custom value */
        var distanceInput = byId('terra-distance');
        if (distanceInput) {
          distanceInput.addEventListener('input', function() {
            syncDistanceChips(distanceInput.value);
          });
        }

        sectionRoot.addEventListener('click', function(event) {
          var aimButton = event.target.closest('#terra-aim-style-grid-' + sectionId + ' .terra-choice-button');
          if (aimButton && sectionRoot.contains(aimButton)) {
            setActive('#terra-aim-style-grid-' + sectionId + ' .terra-choice-button', 'data-aim-style', aimButton.getAttribute('data-aim-style'));
            onUserChange();
            return;
          }

          var multiGridButton = event.target.closest('#terra-multi-grid-layout-' + sectionId + ' .terra-choice-button');
          if (multiGridButton && sectionRoot.contains(multiGridButton)) {
            setActive('#terra-multi-grid-layout-' + sectionId + ' .terra-choice-button', 'data-multi-grid-layout', multiGridButton.getAttribute('data-multi-grid-layout'));
            onUserChange();
            return;
          }

          var purposeButton = event.target.closest('#terra-purpose-grid-' + sectionId + ' .terra-choice-button');
          if (purposeButton && sectionRoot.contains(purposeButton)) {
            setActive('#terra-purpose-grid-' + sectionId + ' .terra-choice-button', 'data-purpose', purposeButton.getAttribute('data-purpose'));
            onUserChange();
            return;
          }

          var gridStrengthButton = event.target.closest('#terra-grid-strength-grid-' + sectionId + ' .terra-choice-button');
          if (gridStrengthButton && sectionRoot.contains(gridStrengthButton)) {
            setActive('#terra-grid-strength-grid-' + sectionId + ' .terra-choice-button', 'data-grid-strength', gridStrengthButton.getAttribute('data-grid-strength'));
            onUserChange();
            return;
          }

          var distanceChip = event.target.closest('#terra-distance-chips-' + sectionId + ' .terra-choice-button');
          if (distanceChip && sectionRoot.contains(distanceChip)) {
            var unit = getActiveUnit();
            var chipValue = distanceChip.getAttribute(unit === 'imperial' ? 'data-distance-imperial' : 'data-distance-metric') || '';
            var distInput = byId('terra-distance');
            if (distInput) distInput.value = chipValue;
            syncDistanceChips(chipValue);
            markNonPromoting();
            onUserChange();
            return;
          }

          var unitButton = event.target.closest('#terra-unit-grid-' + sectionId + ' .terra-choice-button');
          if (unitButton && sectionRoot.contains(unitButton)) {
            var newUnit = unitButton.getAttribute('data-unit');
            /* Capture the previously active unit BEFORE setActive runs
               so refreshUnitDependentControls can interpret the current
               aim input value correctly and convert it. Without this the
               function can't tell what unit the displayed value is in. */
            var prevUnit = getActiveUnit();
            setActive('#terra-unit-grid-' + sectionId + ' .terra-choice-button', 'data-unit', newUnit);
            refreshUnitDependentControls(newUnit, prevUnit);
            /* v51: persist for cross-tool / cross-tab sync. */
            writeStoredUnitSystem(newUnit);
            markNonPromoting();
            onUserChange();
            return;
          }

          var moaRingsButton = event.target.closest('#terra-moa-rings-grid-' + sectionId + ' .terra-choice-button');
          if (moaRingsButton && sectionRoot.contains(moaRingsButton)) {
            setActive('#terra-moa-rings-grid-' + sectionId + ' .terra-choice-button', 'data-moa-rings', moaRingsButton.getAttribute('data-moa-rings'));
            onUserChange();
            return;
          }

          var markerButton = event.target.closest('#terra-marker-grid-' + sectionId + ' .terra-choice-button');
          if (markerButton && sectionRoot.contains(markerButton)) {
            setActive('#terra-marker-grid-' + sectionId + ' .terra-choice-button', 'data-marker', markerButton.getAttribute('data-marker'));
            onUserChange();
            return;
          }

          var holdoverButton = event.target.closest('#terra-holdover-grid-' + sectionId + ' .terra-choice-button');
          if (holdoverButton && sectionRoot.contains(holdoverButton)) {
            setActive('#terra-holdover-grid-' + sectionId + ' .terra-choice-button', 'data-holdover', holdoverButton.getAttribute('data-holdover'));
            onUserChange();
            return;
          }

          var aimMaxButton = event.target.closest('#terra-aim-max-' + sectionId + '');
          if (aimMaxButton && sectionRoot.contains(aimMaxButton)) {
            var slider = byId('terra-aim-size');
            var numIn = byId('terra-aim-size-value');
            if (slider) {
              var max = parseInt(slider.getAttribute('max'), 10) || 150;
              slider.value = String(max);
              /* Slider max is mm; the number input shows display units
                 (mm or in), so convert before writing. v40. */
              if (numIn) numIn.value = String(mmToAimDisplay(max, getActiveUnit()));
              onUserChange();
            }
            return;
          }

          var resetButton = event.target.closest('#terra-preset-reset-' + sectionId + '');
          if (resetButton && sectionRoot.contains(resetButton)) {
            /* Wipe any saved Custom from localStorage and reload the
               default Custom layout from presets.custom. Selecting any
               other preset isn't necessary — applyPreset('custom') will
               see localStorage cleared and fall through to the default. */
            clearCustomPreset();
            applyPreset('custom');
            return;
          }
        });

        var printButton = byId('terra-print');
        if (printButton) printButton.addEventListener('click', printTarget);

        /* Email capture handlers (no-ops if the merchant hasn't
           configured Klaviyo settings — the markup won't have rendered
           and bindEmailCapture early-returns). v46. */
        bindEmailCapture();

        var mobileToggle = byId('terra-mobile-toggle');
        if (mobileToggle) mobileToggle.addEventListener('click', toggleMobilePreview);
      }

      /* ── Initialisation ── */
      function detectDefaultPaperSize() {
        try {
          var timezone = '';
          try {
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
          } catch (timeError) {}

          var locale = '';
          try {
            locale = (navigator.language || (navigator.languages && navigator.languages[0]) || '').toLowerCase();
          } catch (localeError) {}

          var US_ZONES = ['America/New_York', 'America/Chicago', 'America/Denver',
                          'America/Los_Angeles', 'America/Anchorage', 'Pacific/Honolulu'];

          /* TIMEZONE WINS OVER LANGUAGE - do not go back to OR-ing them (v61).
             These two signals disagree constantly and are NOT equally reliable:
             the timezone says where the machine physically is, while the language
             is an OS/browser default the user very likely never chose. en-US is
             the shipped default on huge numbers of Australian Windows and Chrome
             installs - measured on a real AU machine: navigator.language "en-US",
             navigator.languages ["en-US","en-AU"], timezone "Australia/Sydney".

             OR-ing them meant that machine defaulted to LETTER on an Australian
             store. The customer then prints a 216x279 mm target onto A4, and the
             printer scales-to-fit or clips it - silently destroying the true-size
             guarantee on a sheet whose whole purpose is measuring group size in
             millimetres. The print-check ruler catches it, but only if measured.

             So: trust the timezone when we have one, and only fall back to the
             language when the timezone is unavailable. */
          if (timezone) {
            return US_ZONES.indexOf(timezone) !== -1 ? 'LETTER' : 'A4';
          }
          return locale.indexOf('en-us') === 0 ? 'LETTER' : 'A4';
        } catch (error) {
          return 'A4';
        }
      }

      /* v49: URL parameter consumption. Terra-Dial's verify cross-link
         (v54+) and any future Terra-Build deep-links (e.g. from email
         campaigns or QR codes) can pre-fill the customizer by passing:
           ?distance=100m       (or "100yd")
           &unit_system=metric  (or "imperial")
           &calibre=.308 Win
           &rifle=Tikka T3x
           &source=terra-dial   (any string; preserved for analytics)
         All params are optional. Unrecognised params are ignored.
         Run AFTER the default preset has been applied so URL params
         override defaults but the rest of the customizer stays in a
         valid state. The unit-system swap uses the same code path as
         the manual unit toggle so unit-dependent controls (chip
         labels, aim size display) re-evaluate consistently. */
      function applyUrlParams() {
        var params;
        try { params = new URLSearchParams(window.location.search); } catch (e) { return false; }
        if (!params || !params.toString()) return false;

        var applied = false;

        /* Unit system FIRST — affects how distance/aim are interpreted. */
        var unitParam = (params.get('unit_system') || '').toLowerCase();
        if (unitParam === 'metric' || unitParam === 'imperial') {
          var prevUnit = getActiveUnit();
          if (prevUnit !== unitParam) {
            setActive('#terra-unit-grid-' + sectionId + ' .terra-choice-button',
                      'data-unit', unitParam);
            refreshUnitDependentControls(unitParam, prevUnit);
            /* v51: URL-param unit also wins for cross-tool sync. */
            writeStoredUnitSystem(unitParam);
            applied = true;
          }
        }

        var distanceParam = (params.get('distance') || '').trim();
        if (distanceParam) {
          var distanceInput = byId('terra-distance');
          if (distanceInput) {
            /* v55: if distance arrives unitless (e.g. "100" from
               Dial's verify link) and unit_system was just applied,
               append the implied unit so parseDistanceMetres reads
               it correctly. Already-tagged values like "100yd" or
               "91.44m" pass through unchanged. */
            var hasUnit = /[a-z]/i.test(distanceParam);
            var finalDistance = distanceParam;
            if (!hasUnit) {
              var activeUnit = (unitParam === 'metric' || unitParam === 'imperial')
                ? unitParam : getActiveUnit();
              finalDistance = distanceParam + (activeUnit === 'imperial' ? 'yd' : 'm');
            }
            distanceInput.value = finalDistance;
            syncDistanceChips(finalDistance);
            applied = true;
          }
        }

        var calibreParam = (params.get('calibre') || '').trim();
        if (calibreParam) {
          var calibreInput = byId('terra-calibre');
          if (calibreInput) {
            calibreInput.value = calibreParam;
            applied = true;
          }
        }

        var rifleParam = (params.get('rifle') || '').trim();
        if (rifleParam) {
          var rifleInput = byId('terra-rifle');
          if (rifleInput) {
            rifleInput.value = rifleParam;
            applied = true;
          }
        }

        return applied;
      }

      function init() {
        if (!root()) return;
        bind();

        /* Sync aria-pressed on every choice-button from its initial
           .active class (v42-a11y). Subsequent setActive() and
           syncDistanceChips() calls keep aria-pressed in sync; this
           pass covers the brief window between HTML render and the
           first setActive() call, and any choice-button group not
           touched by setActive at startup. Hidden buttons (aria-hidden,
           tabindex=-1, e.g. the sticker-guide preset target) are
           skipped — they're not part of the accessibility tree. */
        forEachNode(root().querySelectorAll('.terra-choice-button'), function(button) {
          if (button.getAttribute('aria-hidden') === 'true') return;
          button.setAttribute('aria-pressed',
            button.classList.contains('active') ? 'true' : 'false');
        });

        var defaultPaperSize = detectDefaultPaperSize();
        byId('terra-paper-size').value = defaultPaperSize;
        setActive('#terra-grid-strength-grid-' + sectionId + ' .terra-choice-button', 'data-grid-strength', 'field');
        setActive('#terra-aim-style-grid-' + sectionId + ' .terra-choice-button', 'data-aim-style', 'dot-only');
        setActive('#terra-marker-grid-' + sectionId + ' .terra-choice-button', 'data-marker', 'auto');
        setActive('#terra-holdover-grid-' + sectionId + ' .terra-choice-button', 'data-holdover', 'off');
        setActive('#terra-unit-grid-' + sectionId + ' .terra-choice-button', 'data-unit', 'metric');
        setActive('#terra-moa-rings-grid-' + sectionId + ' .terra-choice-button', 'data-moa-rings', 'off');
        var initSel = byId('terra-preset-select');
        if (initSel) initSel.value = 'cold_bore_ss';
        updateCustomModeClass(false);

        /* show grid labels by default so MOA/MIL scale is visible */
        var gridLabelsCheckbox = byId('terra-show-grid-labels');
        if (gridLabelsCheckbox) gridLabelsCheckbox.checked = true;

        /* Default values for new field-extras inputs */
        var ethicalSelect = byId('terra-ethical-game');
        if (ethicalSelect && !ethicalSelect.value) ethicalSelect.value = 'off';
        var conditionsChk = byId('terra-conditions-row');
        if (conditionsChk) conditionsChk.checked = false;

        /* Ensure unit-dependent UI (chip labels, grid options) is in sync
           before any preset is applied. */
        refreshUnitDependentControls('metric');

        /* check for saved custom preset */
        loadCustomPreset();

        applyPreset('cold_bore_ss');
        byId('terra-paper-size').value = defaultPaperSize;
        syncDistanceChips(byId('terra-distance').value);
        render();

        /* After first render the slider's max is set to the actual layout
           max. Push the slider to that max so default aim is biggest-fit,
           then re-render once so it appears in the preview. */
        var slider = byId('terra-aim-size');
        if (slider) {
          var max = parseInt(slider.getAttribute('max'), 10) || 150;
          slider.value = String(max);
          render();
        }

        /* v51: Cross-tool unit-system sync — apply the user's most
           recent unit choice (set in any Terra tool with a unit
           toggle). Runs AFTER preset/saved-preset apply so it
           overrides the preset's unit, but BEFORE applyUrlParams
           so any inbound URL param wins (URL > localStorage >
           preset). */
        var storedUnit = readStoredUnitSystem();
        if (storedUnit && applyUnitSystem(storedUnit)) {
          render();
        }

        /* v49: URL params override defaults. Run AFTER the default
           render so unit/distance/calibre/rifle from inbound deep-links
           (e.g. Terra-Dial's verify link) take effect. A final render()
           paints any URL-driven changes. */
        if (applyUrlParams()) {
          render();
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }

      /* v49: bfcache restore. Same pattern as Terra-Dial v53 and
         Terra-Impact V60 — re-run URL param consumption when the page
         is restored from the back/forward cache, so a user navigating
         back to Terra-Build with new params doesn't see stale state.
         Bound at the window level once via the __terraBuildPageshowBound
         sentinel for multi-section deployments. */
      if (!window.__terraBuildPageshowBound) {
        window.__terraBuildPageshowBound = true;
        window.addEventListener('pageshow', function(event) {
          if (event.persisted) {
            if (applyUrlParams()) render();
          }
        });
      }

      /* v51: Cross-tab unit-system sync. When the user toggles
         metric/imperial in another open Terra tool tab, this tab
         updates immediately. Bound once per page via the
         __terraBuildUnitSystemBound sentinel; the storage event
         only fires on OTHER tabs/windows when localStorage is
         written, so we don't need to filter out our own writes. */
      if (!window.__terraBuildUnitSystemBound) {
        window.__terraBuildUnitSystemBound = true;
        window.addEventListener('storage', function(event) {
          if (event.key !== UNIT_SYSTEM_KEY) return;
          if (event.newValue !== 'metric' && event.newValue !== 'imperial') return;
          if (applyUnitSystem(event.newValue)) render();
        });
      }

      document.addEventListener('shopify:section:load', function(event) {
        if (!event.target) return;
        var loadedRoot = event.target.querySelector ? event.target.querySelector('#' + rootId) : null;
        if (loadedRoot) {
          loadedRoot.dataset.terraBound = '';
          init();
        }
      });
    })();
